import {
  LayoutDashboard,
  Users,
  BookOpen,
  ClipboardList,
  Cable,
  Podcast,
  Anchor,
  FileText,
  BookMarked,
  AlertCircle,
  Bot,
  Mail,
  Lightbulb,
  FileType,
  Languages,
  Brain,
  Edit,
  Ticket,
  Gauge,
  Sparkles,
  Earth,
  ListChecks,
  User,
  CircuitBoard,
  ShieldCheck,
  FolderSync,
  BookAudio,
  MessageCircleQuestion,
  TextSelect,
  CalendarCheck,
  Layers,
  GraduationCap,
  Notebook,
  ActivitySquare,
  LibrarySquare,
  Video,
  RocketIcon,
  Telescope,
  SquareMousePointer,
  Map, // Added import for SquareMousePointer
  FolderKanban,
  BookText,
  Activity,
  Calendar, // Added import for SquareMousePointer
} from "lucide-react";

import { TFunction } from "i18next";

import {
  BaseChatDtoCourse,
  BaseTeacherToolResponseDtoToolType,
} from "../api/madlenAPI.schemas";

export const joyrideStyles = {
  beacon: {
    zIndex: 30,
  },
  options: {
    overlayColor: "rgb(0 0 0 / 0.5)",
    primaryColor: "#4F46E5",
    textColor: "#111827",
    zIndex: 30,
    width: 400,
    beaconSize: 36,
  },
  tooltip: {
    borderRadius: "0.75rem",
    padding: "1rem",
  },
  buttonNext: {
    backgroundColor: "#4F46E5",
    borderRadius: "0.5rem",
    padding: "0.5rem 1rem",
    fontSize: "0.875rem",
    fontWeight: 500,
  },
  buttonBack: {
    color: "#6B7280",
    marginRight: "0.75rem",
  },
  buttonSkip: {
    color: "#6B7280",
  },
};

export const joyrideStylesDark = {
  beacon: {
    zIndex: 30,
  },
  options: {
    overlayColor: "rgb(255 255 255 / 0.2)",
    primaryColor: "#4F46E5",
    textColor: "#F9FAFB",
    zIndex: 30,
    width: 400,
    beaconSize: 36,
  },
  tooltip: {
    backgroundColor: "#1F2937",
    borderRadius: "0.75rem",
    padding: "1rem",
  },
  buttonNext: {
    backgroundColor: "#4F46E5",
    borderRadius: "0.5rem",
    padding: "0.5rem 1rem",
    fontSize: "0.875rem",
    fontWeight: 500,
    color: "#F9FAFB",
  },
  buttonBack: {
    color: "#9CA3AF",
  },
  buttonSkip: {
    color: "#9CA3AF",
  },
  buttonClose: {
    // You might need to adjust positioning
  },
};

export const getEnvironment = () => {
  return window.location.hostname.includes("devteacher.madlen.io") ||
    window.location.host.includes("localhost") ||
    window.location.hostname.includes("v2.madlen.io")
    ? "DEV"
    : "PROD";
};

export const menuItemsFunction = (t: TFunction, language?: string) => [
  {
    icon: LayoutDashboard,
    emoji: "📊",
    text: t("sidebar.menu.dashboard"),
    id: "dashboard",
    path: "/dashboard",
    showOnNavbar: false,
    color: "text-gray-700 dark:text-white",
  },
  {
    icon: BookOpen,
    emoji: "📚",
    text: t("sidebar.menu.assignments.title"),
    id: "assignments",
    path: "/assignments",
    color: "text-gray-700 dark:text-white",
  },
  {
    icon: RocketIcon,
    emoji: "📊",
    text: t("sidebar.menu.superTool"),
    id: "super-tool",
    path: "/super-tool",
    showOnNavbar: false,
    color: "text-gray-700 dark:text-white",
  },
  {
    icon: Cable,
    emoji: "🧰",
    text: t("sidebar.menu.toolbox.title"),
    id: "content/tools",
    path: "/content/tools",
    color: "bg-red-500 dark:bg-red-600",
    subPages: toolsList.map((category) => ({
      text: t(category.categoryTitle),
      id: category.category,
      icon: category.icon,
      color: category.colors.iconColor,
      path: "/content/tools?category=" + category.category,
    })),
  },
  {
    icon: Bot,
    emoji: "🤖",
    text: t("sidebar.menu.assistant.title"),
    id: "assistants/new/empty",
    path: "/assistants/new/empty",
    color: "bg-violet-500 dark:bg-violet-600",
    // subPages: assistantsList.map((assistant) => ({
    //   text: t(assistant.title),
    //   id: assistant.path.slice(1), // Remove leading slash
    //   icon: assistant.icon,
    //   color: assistant.colors.menuColor,
    // })),
  },
  {
    icon: ListChecks,
    emoji: "📝",
    text: t("sidebar.menu.assistant.essayGrader"),
    id: "essay-grading",
    path: "/essay-grading",
    color: "bg-blue-500 dark:bg-blue-600",
  },
  // {
  //   icon: Presentation,
  //   emoji: "🎯",
  //   text: t("sidebar.menu.slides.title"),
  //   id: "slides",
  //   color: "bg-emerald-500 dark:bg-emerald-600",
  //   beta: true,
  // },
  ...(getEnvironment() === "DEV"
    ? [
        {
          icon: Telescope,
          emoji: "🔍",
          text: t("sidebar.menu.articleGenerator"),
          id: "content/article-generator",
          path: "/content/article-generator",
          color: "bg-teal-500 dark:bg-teal-600",
        },
      ]
    : []),
  ...(getEnvironment() === "DEV"
    ? [
        {
          icon: Map,
          emoji: "🔍",
          text: t("sidebar.menu.mindmap"),
          id: "content/mindmaps",
          path: "/content/mindmaps",
          color: "bg-teal-500 dark:bg-teal-600",
        },
      ]
    : []),
  {
    icon: FolderKanban,
    emoji: "📋",
    text: t("sidebar.menu.lessonPlanningTools.title"),
    id: "lesson-planning-tools",
    color:
      "bg-gradient-to-r from-emerald-500 to-teal-600 dark:from-emerald-400 dark:to-teal-500",
    subPages: [
      {
        text: t("sidebar.menu.lessonPlanningTools.dailyPlan"),
        id: "lesson-planning-tools/daily-plan",
        path: "/lesson-planning-tools/daily-plan",
        icon: CalendarCheck,
        color:
          "text-emerald-600 dark:text-emerald-400 hover:bg-emerald-50 dark:hover:bg-emerald-900/20",
      },
      ...(language === "tr"
        ? [
            {
              text: t("sidebar.menu.lessonPlanningTools.maarifDailyPlan"),
              id: "lesson-planning-tools/maarif-daily-plan",
              path: "/lesson-planning-tools/maarif-daily-plan",
              icon: BookText,
              color:
                "text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20",
            },
            ...(window.location.href.includes("ted.madlen.io")
              ? [
                  {
                    text: t("sidebar.menu.lessonPlanningTools.tedPlan"),
                    id: "lesson-planning-tools/ted-plan",
                    path: "/lesson-planning-tools/ted-plan",
                    icon: Brain,
                    color:
                      "text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20",
                  },
                ]
              : []),
            ...(getEnvironment() === "DEV"
              ? [
                  {
                    text: t("sidebar.menu.lessonPlanningTools.ubdMaarifPlan"),
                    id: "lesson-planning-tools/ubd-maarif-plan",
                    path: "/lesson-planning-tools/ubd-maarif-plan",
                    icon: Brain,
                    color:
                      "text-purple-600 dark:text-purple-400 hover:bg-purple-50 dark:hover:bg-purple-900/20",
                  },
                ]
              : []),
          ]
        : []),
    ],
  },
  {
    icon: Users,
    emoji: "👩‍🎓",
    text: t("sidebar.menu.students.classroomAnalytics"),
    id: "students",
    path: "/students",
    color: "text-white",
  },
  {
    icon: User,
    emoji: "👤",
    text: t("sidebar.menu.profile"),
    id: "profiles/me",
    path: "/profiles/me",
    color: "text-gray-700 dark:text-white",
  },
];

export const assistantColorSchemes = {
  EMPTY: {
    icon: Brain,
    iconColor: "text-blue-600 dark:text-blue-400",
    gradient:
      "from-blue-600 to-indigo-600 dark:from-blue-400 dark:to-indigo-400",
    bgColor: "bg-blue-100 dark:bg-blue-900/50",
    hoverBg: "hover:bg-blue-50 dark:hover:bg-blue-900/20",
    followups: {
      tr: [
        "Öğrencilerin öğrenme motivasyonunu artırmak için önerileriniz neler?",
        "Etkili sınıf yönetimi için ipuçları paylaşır mısınız?",
        "Öğrencilerin derse katılımını nasıl artırabilirim?",
        "Farklı öğrenme stillerine sahip öğrenciler için önerileriniz neler?",
        "Sınıfta davranış problemleriyle nasıl başa çıkabilirim?",
        "Öğrenci değerlendirme yöntemleri hakkında bilgi verir misiniz?",
        "Velilerle etkili iletişim kurma konusunda önerileriniz neler?",
        "Uzaktan eğitimde öğrenci motivasyonunu nasıl sağlayabilirim?",
        "Derse ilgiyi artırmak için hangi teknikleri kullanmalıyım?",
        "Zorlanan öğrenciler için bireyselleştirilmiş öğrenme nasıl sağlarım?",
        "Öğrencilerin eleştirel düşünme becerilerini geliştirmek için neler yapabilirim?",
        "Yapay zeka destekli öğretim materyali nasıl oluşturabilirim?",
        "Sınıfta aktif öğrenmeyi teşvik etmek için ne yapabilirim?",
        "Öğrencilerimin derse katılımını ölçmek için en iyi yöntemler nelerdir?",
        "Öğrenci başarısını takip etmek için hangi veri analiz yöntemlerini kullanabilirm?",
        "Farklı zekâ türlerine sahip öğrenciler için nasıl ders planlamalıyım?",
        "Öğrencilerimle daha güçlü bir iletişim kurmak için neler yapabilirim?",
        "Sessiz veya çekingen öğrencileri derse nasıl daha fazla dahil edebilirim?",
        "Ders içinde öğrencilerin aktif katılımını artıracak yöntemler nelerdir?",
        "Öğrencilere geri bildirim verirken dikkat etmem gereken en önemli noktalar neler?",
        "Etkili sınıf içi tartışmalar için nasıl bir yöntem izlemeliyim?",
      ],
      en: [
        "What are your suggestions for increasing student learning motivation?",
        "Can you share tips for effective classroom management?",
        "How can I increase student participation in class?",
        "What are your suggestions for students with different learning styles?",
        "How can I deal with behavioral problems in the classroom?",
        "Can you provide information about student assessment methods?",
        "What are your suggestions for effective communication with parents?",
        "How can I maintain student motivation in distance learning?",
        "What techniques should I use to increase interest in the lesson?",
        "How can I provide personalized learning for struggling students?",
        "What can I do to develop students' critical thinking skills?",
        "How can I create AI-supported teaching materials?",
        "What can I do to encourage active learning in the classroom?",
        "What are the best methods to measure my students' class participation?",
        "Which data analysis methods can I use to track student success?",
        "How should I plan lessons for students with different types of intelligence?",
        "What can I do to build stronger communication with my students?",
        "How can I better include quiet or shy students in class?",
        "What are the methods to increase students' active participation during lessons?",
        "What are the most important points to consider when giving feedback to students?",
        "What approach should I follow for effective classroom discussions?",
      ],
      fr: [
        "Quelles sont vos suggestions pour augmenter la motivation d'apprentissage des élèves ?",
        "Pouvez-vous partager des conseils pour une gestion de classe efficace ?",
        "Comment puis-je augmenter la participation des élèves en classe ?",
        "Quelles sont vos suggestions pour les élèves ayant différents styles d'apprentissage ?",
        "Comment gérer les problèmes de comportement en classe ?",
        "Pouvez-vous fournir des informations sur les méthodes d'évaluation des élèves ?",
        "Quelles sont vos suggestions pour une communication efficace avec les parents ?",
        "Comment maintenir la motivation des élèves dans l'enseignement à distance ?",
        "Quelles techniques dois-je utiliser pour augmenter l'intérêt pour la leçon ?",
        "Comment puis-je proposer un apprentissage personnalisé pour les élèves en difficulté ?",
        "Que puis-je faire pour développer l'esprit critique des élèves ?",
        "Comment créer des supports pédagogiques assistés par l'IA ?",
        "Que puis-je faire pour encourager l'apprentissage actif en classe ?",
        "Quelles sont les meilleures méthodes pour mesurer la participation de mes élèves ?",
        "Quelles méthodes d'analyse de données puis-je utiliser pour suivre la réussite des élèves ?",
        "Comment planifier des leçons pour des élèves ayant différents types d'intelligence ?",
        "Que puis-je faire pour renforcer la communication avec mes élèves ?",
        "Comment mieux inclure les élèves calmes ou timides en classe ?",
        "Quelles sont les méthodes pour augmenter la participation active des élèves pendant les cours ?",
        "Quels sont les points les plus importants à considérer lors de la remise de feedback aux élèves ?",
        "Quelle approche dois-je adopter pour des discussions efficaces en classe ?",
      ],
      de: [
        "Welche Vorschläge haben Sie, um die Lernmotivation der Schüler zu steigern?",
        "Können Sie Tipps für ein effektives Klassenmanagement geben?",
        "Wie kann ich die Beteiligung der Schüler am Unterricht erhöhen?",
        "Welche Vorschläge haben Sie für Schüler mit unterschiedlichen Lernstilen?",
        "Wie kann ich mit Verhaltensproblemen im Klassenzimmer umgehen?",
        "Können Sie Informationen zu Methoden der Schülerbewertung geben?",
        "Welche Vorschläge haben Sie für eine effektive Kommunikation mit Eltern?",
        "Wie kann ich die Motivation der Schüler im Fernunterricht aufrechterhalten?",
        "Welche Techniken sollte ich anwenden, um das Interesse am Unterricht zu steigern?",
        "Wie kann ich personalisiertes Lernen für leistungsschwache Schüler anbieten?",
        "Was kann ich tun, um das kritische Denken der Schüler zu fördern?",
        "Wie kann ich KI-gestützte Unterrichtsmaterialien erstellen?",
        "Was kann ich tun, um aktives Lernen im Unterricht zu fördern?",
        "Was sind die besten Methoden, um die Teilnahme meiner Schüler am Unterricht zu messen?",
        "Welche Datenanalysemethoden kann ich verwenden, um den Erfolg der Schüler zu verfolgen?",
        "Wie sollte ich den Unterricht für Schüler mit unterschiedlichen Intelligenztypen planen?",
        "Was kann ich tun, um die Kommunikation mit meinen Schülern zu stärken?",
        "Wie kann ich ruhige oder schüchterne Schüler besser in den Unterricht einbeziehen?",
        "Welche Methoden gibt es, um die aktive Teilnahme der Schüler während des Unterrichts zu erhöhen?",
        "Was sind die wichtigsten Punkte, die ich beim Feedback an Schüler beachten sollte?",
        "Welche Vorgehensweise sollte ich für effektive Klassendiskussionen wählen?",
      ],
    },
  },
  MAIL_EDITOR: {
    icon: Mail,
    iconColor: "text-purple-600 dark:text-purple-400",
    gradient:
      "from-purple-600 to-violet-600 dark:from-purple-400 dark:to-violet-400",
    bgColor: "bg-purple-100 dark:bg-purple-900/50",
    hoverBg: "hover:bg-purple-50 dark:hover:bg-purple-900/20",
    followups: {
      tr: [
        "Veli bilgilendirme e-postasını düzenler misin?",
        "Öğrenciye başarı mesajı yazabilir misin?",
        "Toplantı notlarını e-posta ile paylaşmak için bir taslak oluşturur musun?",
        "Öğrenciler için ders ipuçları içeren bir e-posta hazırlar mısın?",
        "Okul etkinlik duyurusu için e-posta tasarlar mısın?",
        "Bir öğrencinin özgeçmişini paylaşmak için e-posta hazırlar mısın?",
        "Velilerle iletişim için daha profesyonel bir e-posta düzenler misin?",
        "E-posta tonunu daha sıcak ve samimi yapabilir misin?",
      ],
      en: [
        "Could you edit a parent notification email?",
        "Can you write a congratulatory email for a student?",
        "Would you draft an email to share meeting notes?",
        "Can you prepare an email with study tips for students?",
        "Can you design an email for a school event announcement?",
        "Would you create an email to share a student's resume?",
        "Can you make a parent communication email more professional?",
        "Could you adjust the email tone to be warmer and friendlier?",
      ],
    },
  },
  FAST_LESSON_CONTENT_SUMMARIZER: {
    icon: FileText,
    iconColor: "text-green-600 dark:text-green-400",
    gradient:
      "from-green-600 to-emerald-600 dark:from-green-400 dark:to-emerald-400",
    bgColor: "bg-green-100 dark:bg-green-900/50",
    hoverBg: "hover:bg-green-50 dark:hover:bg-green-900/20",
    followups: {
      tr: [
        "Bu ders planını özetler misin?",
        "Bu konunun öğrencilere uygun ana noktalarını çıkarır mısın?",
        "Ders materyalini daha anlaşılır hale getirir misin?",
        "Bu konunun kritik kavramlarını sıralar mısın?",
        "Öğrencilere anlatılacak kısa bir özet oluşturur musun?",
        "Bu içeriği ders notları haline getirebilir misin?",
        "Dersin ana fikirlerini ön plana çıkarır mısın?",
        "Daha sade bir ders özeti oluşturur musun?",
      ],
      en: [
        "Can you summarize this lesson plan?",
        "Could you extract student-friendly key points from this topic?",
        "Can you make this lesson material easier to understand?",
        "Could you list the critical concepts of this topic?",
        "Can you create a brief summary for students?",
        "Would you turn this content into lesson notes?",
        "Can you highlight the main ideas of this lesson?",
        "Could you create a simplified lesson summary?",
      ],
    },
  },
  STEM_PROJECT_IDEAS_GPT: {
    icon: Lightbulb,
    iconColor: "text-yellow-600 dark:text-yellow-400",
    gradient:
      "from-yellow-600 to-amber-600 dark:from-yellow-400 dark:to-amber-400",
    bgColor: "bg-yellow-100 dark:bg-yellow-900/50",
    hoverBg: "hover:bg-yellow-50 dark:hover:bg-yellow-900/20",
    followups: {
      tr: [
        "Öğrenciler için basit bir STEM projesi önerir misin?",
        "Bu bilim konusu için deney fikirleri verir misin?",
        "Matematik dersine uygun bir proje önerir misin?",
        "Teknoloji tabanlı bir aktivite fikri sunar mısın?",
        "Mühendislik uygulaması içeren bir proje örneği verir misin?",
        "Sınıfta yapılabilecek bilimsel bir deney tasarlar mısın?",
        "Kodlama ile ilgili bir etkinlik önerir misin?",
        "Fen ve matematiği birleştiren bir proje fikri sunar mısın?",
      ],
      en: [
        "Can you suggest a simple STEM project for students?",
        "Would you provide experiment ideas for this science topic?",
        "Can you suggest a project suitable for a math class?",
        "Could you propose a technology-based activity?",
        "Would you give an example of an engineering project?",
        "Can you design a scientific experiment for the classroom?",
        "Could you suggest an activity involving coding?",
        "Can you offer a project idea that combines science and math?",
      ],
    },
  },
  DOCUMENT_FORMATTER: {
    icon: FileType,
    iconColor: "text-red-600 dark:text-red-400",
    gradient: "from-red-600 to-rose-600 dark:from-red-400 dark:to-rose-400",
    bgColor: "bg-red-100 dark:bg-red-900/50",
    hoverBg: "hover:bg-red-50 dark:hover:bg-red-900/20",
    followups: {
      tr: [
        "Bu ders planını daha iyi organize eder misin?",
        "Bu değerlendirme raporunu standart bir forma sokar mısın?",
        "Ders materyalini daha okunabilir hale getirir misin?",
        "Bu proje dökümanını düzenli bir şekilde yapılandırır mısın?",
        "Ders için uygun bir formata dönüştürür müsün?",
        "Sunum slaytlarını daha profesyonel hale getirebilir misin?",
        "Ders dokümanını daha görsel olarak çekici yapar mısın?",
        "Bu metni kısa ama etkili bir formata sokabilir misin?",
      ],
      en: [
        "Can you better organize this lesson plan?",
        "Could you format this assessment report into a standard form?",
        "Can you make the lesson material more readable?",
        "Could you structure this project document neatly?",
        "Can you convert this content into a teacher-friendly format?",
        "Would you make the presentation slides more professional?",
        "Can you make this lesson document more visually appealing?",
        "Could you condense this text into a concise and impactful format?",
      ],
    },
  },
  FAST_TRANSLATOR_AND_LANGUAGE_HELPER: {
    icon: Languages,
    iconColor: "text-cyan-600 dark:text-cyan-400",
    gradient: "from-cyan-600 to-cyan-500 dark:from-cyan-400 dark:to-cyan-300",
    bgColor: "bg-cyan-100 dark:bg-cyan-900/50",
    hoverBg: "hover:bg-cyan-50 dark:hover:bg-cyan-900/20",
    followups: {
      tr: [
        "Bu ders notlarını İngilizce'ye çevirir misin?",
        "Bu eğitim teriminin diğer dillerdeki karşılıklarını bulabilir misin?",
        "Bu çeviri öğrenciler için uygun mu?",
        "Eğitim materyalini çevirir misin?",
        "Bu sınıf duyurusunu diğer dillere çevirir misin?",
        "Öğrenciler için bir çeviri uygulaması önerir misin?",
        "Bu çeviriyi daha basit hale getirebilir misin?",
        "Bu kavramın farklı ülkelerdeki karşılıklarını gösterir misin?",
      ],
      en: [
        "Can you translate these lesson notes into English?",
        "Could you find equivalents of this educational term in other languages?",
        "Is this translation suitable for students?",
        "Could you translate an educational material?",
        "Can you translate this class announcement into other languages?",
        "Would you recommend a translation app for students?",
        "Could you simplify this translation?",
        "Can you show the equivalent of this concept in different countries?",
      ],
    },
  },
  ESSAY_GRADER: {
    icon: Edit,
    iconColor: "text-red-600 dark:text-red-400",
    gradient: "from-red-600 to-pink-600 dark:from-red-400 dark:to-pink-400",
    bgColor: "bg-red-100 dark:bg-red-900/50",
    hoverBg: "hover:bg-red-50 dark:hover:bg-red-900/20",
    followups: {
      tr: [
        "Bu makaleyi değerlendirir misin?",
        "Bu kompozisyonun güçlü ve zayıf yönlerini belirtebilir misin?",
        "Bu yazının dilbilgisi ve yazım hatalarını düzeltebilir misin?",
        "Bu makalenin ana fikrini özetleyebilir misin?",
        "Bu kompozisyonun yapısını nasıl geliştirebiliriz?",
        "Bu yazının akıcılığını artırmak için önerilerin var mı?",
        "Bu makalenin argümanlarını nasıl güçlendirebiliriz?",
        "Bu kompozisyonun genel kalitesini nasıl değerlendirirsin?",
      ],
      en: [
        "Can you evaluate this essay?",
        "Could you identify the strengths and weaknesses of this composition?",
        "Can you correct the grammar and spelling errors in this writing?",
        "Could you summarize the main idea of this essay?",
        "How can we improve the structure of this composition?",
        "Do you have any suggestions to enhance the flow of this writing?",
        "How can we strengthen the arguments in this essay?",
        "How would you assess the overall quality of this composition?",
      ],
      fr: [
        "Pouvez-vous évaluer cette dissertation ?",
        "Pourriez-vous identifier les points forts et les faiblesses de cette composition ?",
        "Pouvez-vous corriger les fautes de grammaire et d'orthographe dans ce texte ?",
        "Pourriez-vous résumer l'idée principale de cette dissertation ?",
        "Comment pouvons-nous améliorer la structure de cette composition ?",
        "Avez-vous des suggestions pour améliorer la fluidité de ce texte ?",
        "Comment pouvons-nous renforcer les arguments dans cette dissertation ?",
        "Comment évalueriez-vous la qualité globale de cette composition ?",
      ],
      de: [
        "Können Sie diesen Aufsatz bewerten?",
        "Könnten Sie die Stärken und Schwächen dieser Komposition benennen?",
        "Können Sie die Grammatik- und Rechtschreibfehler in diesem Text korrigieren?",
        "Könnten Sie die Hauptidee dieses Aufsatzes zusammenfassen?",
        "Wie können wir die Struktur dieser Komposition verbessern?",
        "Haben Sie Vorschläge, um den Schreibfluss dieses Textes zu verbessern?",
        "Wie können wir die Argumente in diesem Aufsatz stärken?",
        "Wie würden Sie die Gesamtqualität dieser Komposition beurteilen?",
      ],
    },
  },
};

export const firstTopicOfCourse = (
  grade: number,
  courseType: BaseChatDtoCourse,
) => {
  const allTopics = {
    "5-ENGLISH": {
      id: 10224,
      grade: 5,
      courseType: "ENGLISH",
      chapterName: "SCHOOL LIFE",
      topic: "People, places and rules at school",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "5-SCIENCE": {
      id: 3845,
      grade: 5,
      courseType: "SCIENCE",
      chapterName: "1. Ünite: Gökyüzündeki Komşularımız ve Biz",
      topic: "1. Bölüm: Gökyüzündeki Komşumuz: Güneş",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "5-HISTORY": {
      id: 3869,
      grade: 5,
      courseType: "HISTORY",
      chapterName: "Birlikte Yaşamak",
      topic: "Kitabımızı Tanıyalım",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "5-TURKISH": {
      id: 3896,
      grade: 5,
      courseType: "TURKISH",
      chapterName: "1. Tema: Oyun Dünyası",
      topic: "Oyun Durdu! (dinleme)",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "5-AP_ASTRONOMY": {
      id: 5186,
      grade: null,
      courseType: "AP_ASTRONOMY",
      chapterName: "Science and the Universe: A Brief Tour",
      topic: "Introduction",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "5-AP_PSYCHOLOGY": {
      id: 4184,
      grade: null,
      courseType: "AP_PSYCHOLOGY",
      chapterName: "Introduction to Psychology",
      topic: "What Is Psychology?",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "5-AP_BUSINESS": {
      id: 4910,
      grade: null,
      courseType: "AP_BUSINESS",
      chapterName: "Understanding Economic Systems and Business",
      topic: "The Nature Of Business",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "5-AP_ECONOMICS": {
      id: 5044,
      grade: null,
      courseType: "AP_ECONOMICS",
      chapterName: "Welcome to Economics!",
      topic: "What Is Economics, And Why Is It Important?",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "5-AP_SOCIOLOGY": {
      id: 4716,
      grade: null,
      courseType: "AP_SOCIOLOGY",
      chapterName: "An Introduction to Sociology",
      topic: "What Is Sociology?",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "5-AP_WORLD_HISTORY_1": {
      id: 3938,
      grade: null,
      courseType: "AP_WORLD_HISTORY_1",
      chapterName: "Understanding the Past",
      topic: "Introduction",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "5-AP_WORLD_HISTORY_2": {
      id: 4790,
      grade: null,
      courseType: "AP_WORLD_HISTORY_2",
      chapterName: "Understanding the Past",
      topic: "Introduction",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "5-AP_BIOLOGY": {
      id: 4017,
      grade: null,
      courseType: "AP_BIOLOGY",
      chapterName: "1: The Study of Life",
      topic: "1.1 The Science Of Biology",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "5-AP_CHEMISTRY": {
      id: 5371,
      grade: null,
      courseType: "AP_CHEMISTRY",
      chapterName: "1: Essential Ideas",
      topic: "1.1 Chemistry In Context",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "5-AP_PHYSICS": {
      id: 4272,
      grade: null,
      courseType: "AP_PHYSICS",
      chapterName: "Introduction: The Nature of Science and Physics",
      topic: "Connection For Ap® Courses",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "5-IGCSE_BIOLOGY": {
      id: 9089,
      grade: null,
      courseType: "IGCSE_BIOLOGY",
      chapterName: "Characteristics and classification of living organisms",
      topic: "1.1 Characteristics of living organisms",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.545+00:00",
      language: null,
    },
    "5-IGCSE_PHYSICS": {
      id: 9328,
      grade: null,
      courseType: "IGCSE_PHYSICS",
      chapterName: "Motion, forces and energy",
      topic: "1.1 Physical quantities and measurement techniques",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.547+00:00",
      language: null,
    },
    "5-IGCSE_CHEMISTRY": {
      id: 9252,
      grade: null,
      courseType: "IGCSE_CHEMISTRY",
      chapterName: "States of matter",
      topic: "1.1 Solids, liquids and gases",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.546+00:00",
      language: null,
    },
    "5-IGCSE_BUSINESS_STUDIES": {
      id: 9303,
      grade: null,
      courseType: "IGCSE_BUSINESS_STUDIES",
      chapterName: "Understanding business activity",
      topic: "1.1 Business activity",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.547+00:00",
      language: null,
    },
    "5-IGCSE_ECONOMICS": {
      id: 9153,
      grade: null,
      courseType: "IGCSE_ECONOMICS",
      chapterName: "The basic economic problem",
      topic: "1.1 The nature of the economic problem",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.545+00:00",
      language: null,
    },
    "5-IGCSE_COMPUTER_SCIENCE": {
      id: 9192,
      grade: null,
      courseType: "IGCSE_COMPUTER_SCIENCE",
      chapterName: "Data representation",
      topic: "1.1 Number systems",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.546+00:00",
      language: null,
    },
    "5-IGCSE_GEOGRAPHY": {
      id: 9070,
      grade: null,
      courseType: "IGCSE_GEOGRAPHY",
      chapterName: "Population and settlement",
      topic: "1.1 Population dynamics",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.544+00:00",
      language: null,
    },
    "5-IGCSE_HISTORY": {
      id: 9221,
      grade: null,
      courseType: "IGCSE_HISTORY",
      chapterName:
        "Core content: Option A: The nineteenth century: the development of modern nation states, 1848–1914",
      topic: "1 Were the revolutions of 1848 important?",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.546+00:00",
      language: null,
    },
    "5-IGCSE_MATHEMATICS": {
      id: 8997,
      grade: null,
      courseType: "IGCSE_MATHEMATICS",
      chapterName: "Number",
      topic: "C1.1 Types of number",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.544+00:00",
      language: null,
    },
    "5-IB_DP_GEOGRAPHY": {
      id: 9579,
      grade: null,
      courseType: "IB_DP_GEOGRAPHY",
      chapterName: "Geographic themes-seven options",
      topic: "Freshwater",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.168+00:00",
      language: null,
    },
    "5-IB_DP_BUSINESS_MANAGEMENT": {
      id: 9542,
      grade: null,
      courseType: "IB_DP_BUSINESS_MANAGEMENT",
      chapterName: "Unit 1: Introduction to business management",
      topic: "1.1 What is a business?",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "5-IB_DP_CHEMISTRY": {
      id: 9520,
      grade: null,
      courseType: "IB_DP_CHEMISTRY",
      chapterName: "Structure 1. Models of the particulate nature of matter",
      topic: "Structure 1.1-Introduction to the particulate nature of matter",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "5-IB_DP_BIOLOGY": {
      id: 9480,
      grade: null,
      courseType: "IB_DP_BIOLOGY",
      chapterName: "Unity and diversity",
      topic: "Water",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "5-IB_DP_ECONOMICS": {
      id: 9449,
      grade: null,
      courseType: "IB_DP_ECONOMICS",
      chapterName: "Unit 1: Introduction to economics",
      topic: "1.1 What is economics?",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "5-IB_DP_HISTORY": {
      id: 9427,
      grade: null,
      courseType: "IB_DP_HISTORY",
      chapterName: "Prescribed subjects",
      topic: "Military leaders",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "5-IB_DP_PHYSICS": {
      id: 9403,
      grade: null,
      courseType: "IB_DP_PHYSICS",
      chapterName: "A Space, time and motion",
      topic: "A.1 Kinematics •",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "5-IB_DP_COMPUTER_SCIENCE": {
      id: 9392,
      grade: null,
      courseType: "IB_DP_COMPUTER_SCIENCE",
      chapterName: "Topic 1: System fundamentals",
      topic: "Topic 1: System fundamentals",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "5-IB_DP_MATHEMATICS": {
      id: 9387,
      grade: null,
      courseType: "IB_DP_MATHEMATICS",
      chapterName: "Number and algebra",
      topic: "Number and algebra",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "5-ALEVEL_BIOLOGY": {
      id: 10115,
      grade: null,
      courseType: "ALEVEL_BIOLOGY",
      chapterName: "Cell structure (AS Level)",
      topic: "1.1 The microscope in cell\nstudies",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.343+00:00",
      language: null,
    },
    "5-ALEVEL_BUSSINESS": {
      id: 9832,
      grade: null,
      courseType: "ALEVEL_BUSSINESS",
      chapterName: "Business and its environment (AS Level)",
      topic: "1.1 Enterprise",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.340+00:00",
      language: null,
    },
    "5-ALEVEL_CHEMISTRY": {
      id: 9648,
      grade: null,
      courseType: "ALEVEL_CHEMISTRY",
      chapterName: "Atomic structure",
      topic: "1.1 Particles in the atom and atomic radius",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.337+00:00",
      language: null,
    },
    "5-ALEVEL_COMPUTER_SCIENCE": {
      id: 9750,
      grade: null,
      courseType: "ALEVEL_COMPUTER_SCIENCE",
      chapterName: "Information representation",
      topic: "1.1 Data Representation",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.338+00:00",
      language: null,
    },
    "5-ALEVEL_ECONOMICS": {
      id: 9883,
      grade: null,
      courseType: "ALEVEL_ECONOMICS",
      chapterName: "Basic economic ideas and resource allocation (AS Level)",
      topic: "1.1 Scarcity, choice and opportunity cost",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.340+00:00",
      language: null,
    },
    "5-ALEVEL_EUROPEAN_HISTORY": {
      id: 9725,
      grade: null,
      courseType: "ALEVEL_EUROPEAN_HISTORY",
      chapterName: "Modern Europe, 1774-1924: France, 1774–1814",
      topic:
        "1.1 What were the causes and immediate consequences of the 1789 Revolution?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.338+00:00",
      language: null,
    },
    "5-ALEVEL_FURTHER_MATHEMATICS": {
      id: 9937,
      grade: null,
      courseType: "ALEVEL_FURTHER_MATHEMATICS",
      chapterName: "Further Pure Mathematics 1 (for Paper 1)",
      topic: "1.1 Roots of polynomial equations",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.341+00:00",
      language: null,
    },
    "5-ALEVEL_GEOGRAPHY": {
      id: 10059,
      grade: null,
      courseType: "ALEVEL_GEOGRAPHY",
      chapterName: "Hydrology and fluvial geomorphology",
      topic: "1.1 The drainage basin system",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.342+00:00",
      language: null,
    },
    "5-ALEVEL_INTERNATIONAL_HISTORY": {
      id: 10035,
      grade: null,
      courseType: "ALEVEL_INTERNATIONAL_HISTORY",
      chapterName: "Imperialism and the emergence of world powers c.1870–1918",
      topic: "1.1 Why was imperialism a significant force in Africa from 1870?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.342+00:00",
      language: null,
    },
    "5-ALEVEL_MATHEMATICS": {
      id: 9794,
      grade: null,
      courseType: "ALEVEL_MATHEMATICS",
      chapterName: "Pure Mathematics 1 (for Paper 1)",
      topic: "1.1 Quadratics",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.339+00:00",
      language: null,
    },
    "5-ALEVEL_PHYSICS": {
      id: 9961,
      grade: null,
      courseType: "ALEVEL_PHYSICS",
      chapterName: "Physical quantities and units",
      topic: "1.1 Physical quantities",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.341+00:00",
      language: null,
    },
    "5-ALEVEL_SOCIOLOGY": {
      id: 9598,
      grade: null,
      courseType: "ALEVEL_SOCIOLOGY",
      chapterName: "Socialisation and the creation of social identity",
      topic: "1.1 The process of learning and socialisation",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.336+00:00",
      language: null,
    },
    "5-ALEVEL_US_HISTORY_SINCE_1877": {
      id: 9868,
      grade: null,
      courseType: "ALEVEL_US_HISTORY_SINCE_1877",
      chapterName: "The Gilded Age and Progressive Era",
      topic:
        "1.1 What were the impacts of rapid economic growth in the US during the Gilded Age?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.340+00:00",
      language: null,
    },
    "5-ALEVEL_US_HISTORY_TO_1877": {
      id: 9633,
      grade: null,
      courseType: "ALEVEL_US_HISTORY_TO_1877",
      chapterName: "The American Civil War and Reconstruction, 1846–77.",
      topic:
        "1.1 How and why did sectional divisions widen between 1846 and 1861, resulting in the \n American Civil War?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.336+00:00",
      language: null,
    },
    "6-ENGLISH": {
      id: 10250,
      grade: 6,
      courseType: "ENGLISH",
      chapterName: "SCHOOL LIFE",
      topic: "Roles and responsibilities at school",
      deletedOn: null,
      updatedAt: "2025-06-09T17:00:21.649+00:00",
      language: null,
    },
    "6-SCIENCE": {
      id: 2941,
      grade: 6,
      courseType: "SCIENCE",
      chapterName: "1. ÜNİTE: GÜNEŞ SİSTEMİ VE TUTULMALAR",
      topic: "Güneş Sistemi",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "6-HISTORY": {
      id: 2907,
      grade: 6,
      courseType: "HISTORY",
      chapterName: "BİZ VE DEĞERLERİMİZ",
      topic: "Toplumdaki Rollerim",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "6-TURKISH": {
      id: 2864,
      grade: 6,
      courseType: "TURKISH",
      chapterName: "DUYGULAR",
      topic: "Renk Çemberi",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "6-DIGITAL_CITIZENSHIP": {
      id: 7324,
      grade: 6,
      courseType: "DIGITAL_CITIZENSHIP",
      chapterName: "Dijital Dünyada Dengeyi Bulmak",
      topic: "Dijital Dünyada Dengeyi Bulmak",
      deletedOn: null,
      updatedAt: "2024-12-06T17:53:39.000+00:00",
      language: null,
    },
    "6-AP_ASTRONOMY": {
      id: 5186,
      grade: null,
      courseType: "AP_ASTRONOMY",
      chapterName: "Science and the Universe: A Brief Tour",
      topic: "Introduction",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "6-AP_PSYCHOLOGY": {
      id: 4184,
      grade: null,
      courseType: "AP_PSYCHOLOGY",
      chapterName: "Introduction to Psychology",
      topic: "What Is Psychology?",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "6-AP_BUSINESS": {
      id: 4910,
      grade: null,
      courseType: "AP_BUSINESS",
      chapterName: "Understanding Economic Systems and Business",
      topic: "The Nature Of Business",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "6-AP_ECONOMICS": {
      id: 5044,
      grade: null,
      courseType: "AP_ECONOMICS",
      chapterName: "Welcome to Economics!",
      topic: "What Is Economics, And Why Is It Important?",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "6-AP_SOCIOLOGY": {
      id: 4716,
      grade: null,
      courseType: "AP_SOCIOLOGY",
      chapterName: "An Introduction to Sociology",
      topic: "What Is Sociology?",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "6-AP_WORLD_HISTORY_1": {
      id: 3938,
      grade: null,
      courseType: "AP_WORLD_HISTORY_1",
      chapterName: "Understanding the Past",
      topic: "Introduction",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "6-AP_WORLD_HISTORY_2": {
      id: 4790,
      grade: null,
      courseType: "AP_WORLD_HISTORY_2",
      chapterName: "Understanding the Past",
      topic: "Introduction",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "6-AP_BIOLOGY": {
      id: 4017,
      grade: null,
      courseType: "AP_BIOLOGY",
      chapterName: "1: The Study of Life",
      topic: "1.1 The Science Of Biology",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "6-AP_CHEMISTRY": {
      id: 5371,
      grade: null,
      courseType: "AP_CHEMISTRY",
      chapterName: "1: Essential Ideas",
      topic: "1.1 Chemistry In Context",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "6-AP_PHYSICS": {
      id: 4272,
      grade: null,
      courseType: "AP_PHYSICS",
      chapterName: "Introduction: The Nature of Science and Physics",
      topic: "Connection For Ap® Courses",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "6-IGCSE_BIOLOGY": {
      id: 9089,
      grade: null,
      courseType: "IGCSE_BIOLOGY",
      chapterName: "Characteristics and classification of living organisms",
      topic: "1.1 Characteristics of living organisms",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.545+00:00",
      language: null,
    },
    "6-IGCSE_PHYSICS": {
      id: 9328,
      grade: null,
      courseType: "IGCSE_PHYSICS",
      chapterName: "Motion, forces and energy",
      topic: "1.1 Physical quantities and measurement techniques",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.547+00:00",
      language: null,
    },
    "6-IGCSE_CHEMISTRY": {
      id: 9252,
      grade: null,
      courseType: "IGCSE_CHEMISTRY",
      chapterName: "States of matter",
      topic: "1.1 Solids, liquids and gases",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.546+00:00",
      language: null,
    },
    "6-IGCSE_BUSINESS_STUDIES": {
      id: 9303,
      grade: null,
      courseType: "IGCSE_BUSINESS_STUDIES",
      chapterName: "Understanding business activity",
      topic: "1.1 Business activity",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.547+00:00",
      language: null,
    },
    "6-IGCSE_ECONOMICS": {
      id: 9153,
      grade: null,
      courseType: "IGCSE_ECONOMICS",
      chapterName: "The basic economic problem",
      topic: "1.1 The nature of the economic problem",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.545+00:00",
      language: null,
    },
    "6-IGCSE_COMPUTER_SCIENCE": {
      id: 9192,
      grade: null,
      courseType: "IGCSE_COMPUTER_SCIENCE",
      chapterName: "Data representation",
      topic: "1.1 Number systems",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.546+00:00",
      language: null,
    },
    "6-IGCSE_GEOGRAPHY": {
      id: 9070,
      grade: null,
      courseType: "IGCSE_GEOGRAPHY",
      chapterName: "Population and settlement",
      topic: "1.1 Population dynamics",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.544+00:00",
      language: null,
    },
    "6-IGCSE_HISTORY": {
      id: 9221,
      grade: null,
      courseType: "IGCSE_HISTORY",
      chapterName:
        "Core content: Option A: The nineteenth century: the development of modern nation states, 1848–1914",
      topic: "1 Were the revolutions of 1848 important?",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.546+00:00",
      language: null,
    },
    "6-IGCSE_MATHEMATICS": {
      id: 8997,
      grade: null,
      courseType: "IGCSE_MATHEMATICS",
      chapterName: "Number",
      topic: "C1.1 Types of number",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.544+00:00",
      language: null,
    },
    "6-IB_DP_GEOGRAPHY": {
      id: 9579,
      grade: null,
      courseType: "IB_DP_GEOGRAPHY",
      chapterName: "Geographic themes-seven options",
      topic: "Freshwater",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.168+00:00",
      language: null,
    },
    "6-IB_DP_BUSINESS_MANAGEMENT": {
      id: 9542,
      grade: null,
      courseType: "IB_DP_BUSINESS_MANAGEMENT",
      chapterName: "Unit 1: Introduction to business management",
      topic: "1.1 What is a business?",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "6-IB_DP_CHEMISTRY": {
      id: 9520,
      grade: null,
      courseType: "IB_DP_CHEMISTRY",
      chapterName: "Structure 1. Models of the particulate nature of matter",
      topic: "Structure 1.1-Introduction to the particulate nature of matter",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "6-IB_DP_BIOLOGY": {
      id: 9480,
      grade: null,
      courseType: "IB_DP_BIOLOGY",
      chapterName: "Unity and diversity",
      topic: "Water",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "6-IB_DP_ECONOMICS": {
      id: 9449,
      grade: null,
      courseType: "IB_DP_ECONOMICS",
      chapterName: "Unit 1: Introduction to economics",
      topic: "1.1 What is economics?",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "6-IB_DP_HISTORY": {
      id: 9427,
      grade: null,
      courseType: "IB_DP_HISTORY",
      chapterName: "Prescribed subjects",
      topic: "Military leaders",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "6-IB_DP_PHYSICS": {
      id: 9403,
      grade: null,
      courseType: "IB_DP_PHYSICS",
      chapterName: "A Space, time and motion",
      topic: "A.1 Kinematics •",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "6-IB_DP_COMPUTER_SCIENCE": {
      id: 9392,
      grade: null,
      courseType: "IB_DP_COMPUTER_SCIENCE",
      chapterName: "Topic 1: System fundamentals",
      topic: "Topic 1: System fundamentals",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "6-IB_DP_MATHEMATICS": {
      id: 9387,
      grade: null,
      courseType: "IB_DP_MATHEMATICS",
      chapterName: "Number and algebra",
      topic: "Number and algebra",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "6-ALEVEL_BIOLOGY": {
      id: 10115,
      grade: null,
      courseType: "ALEVEL_BIOLOGY",
      chapterName: "Cell structure (AS Level)",
      topic: "1.1 The microscope in cell\nstudies",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.343+00:00",
      language: null,
    },
    "6-ALEVEL_BUSSINESS": {
      id: 9832,
      grade: null,
      courseType: "ALEVEL_BUSSINESS",
      chapterName: "Business and its environment (AS Level)",
      topic: "1.1 Enterprise",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.340+00:00",
      language: null,
    },
    "6-ALEVEL_CHEMISTRY": {
      id: 9648,
      grade: null,
      courseType: "ALEVEL_CHEMISTRY",
      chapterName: "Atomic structure",
      topic: "1.1 Particles in the atom and atomic radius",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.337+00:00",
      language: null,
    },
    "6-ALEVEL_COMPUTER_SCIENCE": {
      id: 9750,
      grade: null,
      courseType: "ALEVEL_COMPUTER_SCIENCE",
      chapterName: "Information representation",
      topic: "1.1 Data Representation",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.338+00:00",
      language: null,
    },
    "6-ALEVEL_ECONOMICS": {
      id: 9883,
      grade: null,
      courseType: "ALEVEL_ECONOMICS",
      chapterName: "Basic economic ideas and resource allocation (AS Level)",
      topic: "1.1 Scarcity, choice and opportunity cost",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.340+00:00",
      language: null,
    },
    "6-ALEVEL_EUROPEAN_HISTORY": {
      id: 9725,
      grade: null,
      courseType: "ALEVEL_EUROPEAN_HISTORY",
      chapterName: "Modern Europe, 1774-1924: France, 1774–1814",
      topic:
        "1.1 What were the causes and immediate consequences of the 1789 Revolution?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.338+00:00",
      language: null,
    },
    "6-ALEVEL_FURTHER_MATHEMATICS": {
      id: 9937,
      grade: null,
      courseType: "ALEVEL_FURTHER_MATHEMATICS",
      chapterName: "Further Pure Mathematics 1 (for Paper 1)",
      topic: "1.1 Roots of polynomial equations",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.341+00:00",
      language: null,
    },
    "6-ALEVEL_GEOGRAPHY": {
      id: 10059,
      grade: null,
      courseType: "ALEVEL_GEOGRAPHY",
      chapterName: "Hydrology and fluvial geomorphology",
      topic: "1.1 The drainage basin system",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.342+00:00",
      language: null,
    },
    "6-ALEVEL_INTERNATIONAL_HISTORY": {
      id: 10035,
      grade: null,
      courseType: "ALEVEL_INTERNATIONAL_HISTORY",
      chapterName: "Imperialism and the emergence of world powers c.1870–1918",
      topic: "1.1 Why was imperialism a significant force in Africa from 1870?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.342+00:00",
      language: null,
    },
    "6-ALEVEL_MATHEMATICS": {
      id: 9794,
      grade: null,
      courseType: "ALEVEL_MATHEMATICS",
      chapterName: "Pure Mathematics 1 (for Paper 1)",
      topic: "1.1 Quadratics",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.339+00:00",
      language: null,
    },
    "6-ALEVEL_PHYSICS": {
      id: 9961,
      grade: null,
      courseType: "ALEVEL_PHYSICS",
      chapterName: "Physical quantities and units",
      topic: "1.1 Physical quantities",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.341+00:00",
      language: null,
    },
    "6-ALEVEL_SOCIOLOGY": {
      id: 9598,
      grade: null,
      courseType: "ALEVEL_SOCIOLOGY",
      chapterName: "Socialisation and the creation of social identity",
      topic: "1.1 The process of learning and socialisation",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.336+00:00",
      language: null,
    },
    "6-ALEVEL_US_HISTORY_SINCE_1877": {
      id: 9868,
      grade: null,
      courseType: "ALEVEL_US_HISTORY_SINCE_1877",
      chapterName: "The Gilded Age and Progressive Era",
      topic:
        "1.1 What were the impacts of rapid economic growth in the US during the Gilded Age?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.340+00:00",
      language: null,
    },
    "6-ALEVEL_US_HISTORY_TO_1877": {
      id: 9633,
      grade: null,
      courseType: "ALEVEL_US_HISTORY_TO_1877",
      chapterName: "The American Civil War and Reconstruction, 1846–77.",
      topic:
        "1.1 How and why did sectional divisions widen between 1846 and 1861, resulting in the \n American Civil War?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.336+00:00",
      language: null,
    },
    "7-ENGLISH": {
      id: 10268,
      grade: 7,
      courseType: "ENGLISH",
      chapterName: "SCHOOL LIFE & EDUCATION",
      topic: "Extra-curricular activities at school",
      deletedOn: null,
      updatedAt: "2025-06-09T17:00:21.649+00:00",
      language: null,
    },
    "7-SCIENCE": {
      id: 2845,
      grade: 7,
      courseType: "SCIENCE",
      chapterName: "1. ÜNİTE: GÜNEŞ SİSTEMİ VE ÖTESİ/DÜNYA VE EVREN",
      topic: "1.1. Uzay Araştırmaları",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "7-HISTORY": {
      id: 2816,
      grade: 7,
      courseType: "HISTORY",
      chapterName: "BİREY VE TOPLUM",
      topic: "İnsandan İnsana Giden Yol",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "7-TURKISH": {
      id: 2776,
      grade: 7,
      courseType: "TURKISH",
      chapterName: "Duygular",
      topic: "Bir Dünya Düşünürüm",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "7-DIGITAL_CITIZENSHIP": {
      id: 7330,
      grade: 7,
      courseType: "DIGITAL_CITIZENSHIP",
      chapterName: "Medya Kullanımımız: Kişisel Bir Meydan Okuma",
      topic: "Medya Kullanımımız: Kişisel Bir Meydan Okuma",
      deletedOn: null,
      updatedAt: "2024-12-06T17:53:39.000+00:00",
      language: null,
    },
    "7-AP_ASTRONOMY": {
      id: 5186,
      grade: null,
      courseType: "AP_ASTRONOMY",
      chapterName: "Science and the Universe: A Brief Tour",
      topic: "Introduction",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "7-AP_PSYCHOLOGY": {
      id: 4184,
      grade: null,
      courseType: "AP_PSYCHOLOGY",
      chapterName: "Introduction to Psychology",
      topic: "What Is Psychology?",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "7-AP_BUSINESS": {
      id: 4910,
      grade: null,
      courseType: "AP_BUSINESS",
      chapterName: "Understanding Economic Systems and Business",
      topic: "The Nature Of Business",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "7-AP_ECONOMICS": {
      id: 5044,
      grade: null,
      courseType: "AP_ECONOMICS",
      chapterName: "Welcome to Economics!",
      topic: "What Is Economics, And Why Is It Important?",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "7-AP_SOCIOLOGY": {
      id: 4716,
      grade: null,
      courseType: "AP_SOCIOLOGY",
      chapterName: "An Introduction to Sociology",
      topic: "What Is Sociology?",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "7-AP_WORLD_HISTORY_1": {
      id: 3938,
      grade: null,
      courseType: "AP_WORLD_HISTORY_1",
      chapterName: "Understanding the Past",
      topic: "Introduction",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "7-AP_WORLD_HISTORY_2": {
      id: 4790,
      grade: null,
      courseType: "AP_WORLD_HISTORY_2",
      chapterName: "Understanding the Past",
      topic: "Introduction",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "7-AP_BIOLOGY": {
      id: 4017,
      grade: null,
      courseType: "AP_BIOLOGY",
      chapterName: "1: The Study of Life",
      topic: "1.1 The Science Of Biology",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "7-AP_CHEMISTRY": {
      id: 5371,
      grade: null,
      courseType: "AP_CHEMISTRY",
      chapterName: "1: Essential Ideas",
      topic: "1.1 Chemistry In Context",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "7-AP_PHYSICS": {
      id: 4272,
      grade: null,
      courseType: "AP_PHYSICS",
      chapterName: "Introduction: The Nature of Science and Physics",
      topic: "Connection For Ap® Courses",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "7-IGCSE_BIOLOGY": {
      id: 9089,
      grade: null,
      courseType: "IGCSE_BIOLOGY",
      chapterName: "Characteristics and classification of living organisms",
      topic: "1.1 Characteristics of living organisms",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.545+00:00",
      language: null,
    },
    "7-IGCSE_PHYSICS": {
      id: 9328,
      grade: null,
      courseType: "IGCSE_PHYSICS",
      chapterName: "Motion, forces and energy",
      topic: "1.1 Physical quantities and measurement techniques",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.547+00:00",
      language: null,
    },
    "7-IGCSE_CHEMISTRY": {
      id: 9252,
      grade: null,
      courseType: "IGCSE_CHEMISTRY",
      chapterName: "States of matter",
      topic: "1.1 Solids, liquids and gases",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.546+00:00",
      language: null,
    },
    "7-IGCSE_BUSINESS_STUDIES": {
      id: 9303,
      grade: null,
      courseType: "IGCSE_BUSINESS_STUDIES",
      chapterName: "Understanding business activity",
      topic: "1.1 Business activity",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.547+00:00",
      language: null,
    },
    "7-IGCSE_ECONOMICS": {
      id: 9153,
      grade: null,
      courseType: "IGCSE_ECONOMICS",
      chapterName: "The basic economic problem",
      topic: "1.1 The nature of the economic problem",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.545+00:00",
      language: null,
    },
    "7-IGCSE_COMPUTER_SCIENCE": {
      id: 9192,
      grade: null,
      courseType: "IGCSE_COMPUTER_SCIENCE",
      chapterName: "Data representation",
      topic: "1.1 Number systems",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.546+00:00",
      language: null,
    },
    "7-IGCSE_GEOGRAPHY": {
      id: 9070,
      grade: null,
      courseType: "IGCSE_GEOGRAPHY",
      chapterName: "Population and settlement",
      topic: "1.1 Population dynamics",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.544+00:00",
      language: null,
    },
    "7-IGCSE_HISTORY": {
      id: 9221,
      grade: null,
      courseType: "IGCSE_HISTORY",
      chapterName:
        "Core content: Option A: The nineteenth century: the development of modern nation states, 1848–1914",
      topic: "1 Were the revolutions of 1848 important?",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.546+00:00",
      language: null,
    },
    "7-IGCSE_MATHEMATICS": {
      id: 8997,
      grade: null,
      courseType: "IGCSE_MATHEMATICS",
      chapterName: "Number",
      topic: "C1.1 Types of number",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.544+00:00",
      language: null,
    },
    "7-IB_DP_GEOGRAPHY": {
      id: 9579,
      grade: null,
      courseType: "IB_DP_GEOGRAPHY",
      chapterName: "Geographic themes-seven options",
      topic: "Freshwater",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.168+00:00",
      language: null,
    },
    "7-IB_DP_BUSINESS_MANAGEMENT": {
      id: 9542,
      grade: null,
      courseType: "IB_DP_BUSINESS_MANAGEMENT",
      chapterName: "Unit 1: Introduction to business management",
      topic: "1.1 What is a business?",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "7-IB_DP_CHEMISTRY": {
      id: 9520,
      grade: null,
      courseType: "IB_DP_CHEMISTRY",
      chapterName: "Structure 1. Models of the particulate nature of matter",
      topic: "Structure 1.1-Introduction to the particulate nature of matter",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "7-IB_DP_BIOLOGY": {
      id: 9480,
      grade: null,
      courseType: "IB_DP_BIOLOGY",
      chapterName: "Unity and diversity",
      topic: "Water",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "7-IB_DP_ECONOMICS": {
      id: 9449,
      grade: null,
      courseType: "IB_DP_ECONOMICS",
      chapterName: "Unit 1: Introduction to economics",
      topic: "1.1 What is economics?",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "7-IB_DP_HISTORY": {
      id: 9427,
      grade: null,
      courseType: "IB_DP_HISTORY",
      chapterName: "Prescribed subjects",
      topic: "Military leaders",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "7-IB_DP_PHYSICS": {
      id: 9403,
      grade: null,
      courseType: "IB_DP_PHYSICS",
      chapterName: "A Space, time and motion",
      topic: "A.1 Kinematics •",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "7-IB_DP_COMPUTER_SCIENCE": {
      id: 9392,
      grade: null,
      courseType: "IB_DP_COMPUTER_SCIENCE",
      chapterName: "Topic 1: System fundamentals",
      topic: "Topic 1: System fundamentals",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "7-IB_DP_MATHEMATICS": {
      id: 9387,
      grade: null,
      courseType: "IB_DP_MATHEMATICS",
      chapterName: "Number and algebra",
      topic: "Number and algebra",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "7-ALEVEL_BIOLOGY": {
      id: 10115,
      grade: null,
      courseType: "ALEVEL_BIOLOGY",
      chapterName: "Cell structure (AS Level)",
      topic: "1.1 The microscope in cell\nstudies",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.343+00:00",
      language: null,
    },
    "7-ALEVEL_BUSSINESS": {
      id: 9832,
      grade: null,
      courseType: "ALEVEL_BUSSINESS",
      chapterName: "Business and its environment (AS Level)",
      topic: "1.1 Enterprise",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.340+00:00",
      language: null,
    },
    "7-ALEVEL_CHEMISTRY": {
      id: 9648,
      grade: null,
      courseType: "ALEVEL_CHEMISTRY",
      chapterName: "Atomic structure",
      topic: "1.1 Particles in the atom and atomic radius",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.337+00:00",
      language: null,
    },
    "7-ALEVEL_COMPUTER_SCIENCE": {
      id: 9750,
      grade: null,
      courseType: "ALEVEL_COMPUTER_SCIENCE",
      chapterName: "Information representation",
      topic: "1.1 Data Representation",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.338+00:00",
      language: null,
    },
    "7-ALEVEL_ECONOMICS": {
      id: 9883,
      grade: null,
      courseType: "ALEVEL_ECONOMICS",
      chapterName: "Basic economic ideas and resource allocation (AS Level)",
      topic: "1.1 Scarcity, choice and opportunity cost",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.340+00:00",
      language: null,
    },
    "7-ALEVEL_EUROPEAN_HISTORY": {
      id: 9725,
      grade: null,
      courseType: "ALEVEL_EUROPEAN_HISTORY",
      chapterName: "Modern Europe, 1774-1924: France, 1774–1814",
      topic:
        "1.1 What were the causes and immediate consequences of the 1789 Revolution?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.338+00:00",
      language: null,
    },
    "7-ALEVEL_FURTHER_MATHEMATICS": {
      id: 9937,
      grade: null,
      courseType: "ALEVEL_FURTHER_MATHEMATICS",
      chapterName: "Further Pure Mathematics 1 (for Paper 1)",
      topic: "1.1 Roots of polynomial equations",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.341+00:00",
      language: null,
    },
    "7-ALEVEL_GEOGRAPHY": {
      id: 10059,
      grade: null,
      courseType: "ALEVEL_GEOGRAPHY",
      chapterName: "Hydrology and fluvial geomorphology",
      topic: "1.1 The drainage basin system",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.342+00:00",
      language: null,
    },
    "7-ALEVEL_INTERNATIONAL_HISTORY": {
      id: 10035,
      grade: null,
      courseType: "ALEVEL_INTERNATIONAL_HISTORY",
      chapterName: "Imperialism and the emergence of world powers c.1870–1918",
      topic: "1.1 Why was imperialism a significant force in Africa from 1870?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.342+00:00",
      language: null,
    },
    "7-ALEVEL_MATHEMATICS": {
      id: 9794,
      grade: null,
      courseType: "ALEVEL_MATHEMATICS",
      chapterName: "Pure Mathematics 1 (for Paper 1)",
      topic: "1.1 Quadratics",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.339+00:00",
      language: null,
    },
    "7-ALEVEL_PHYSICS": {
      id: 9961,
      grade: null,
      courseType: "ALEVEL_PHYSICS",
      chapterName: "Physical quantities and units",
      topic: "1.1 Physical quantities",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.341+00:00",
      language: null,
    },
    "7-ALEVEL_SOCIOLOGY": {
      id: 9598,
      grade: null,
      courseType: "ALEVEL_SOCIOLOGY",
      chapterName: "Socialisation and the creation of social identity",
      topic: "1.1 The process of learning and socialisation",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.336+00:00",
      language: null,
    },
    "7-ALEVEL_US_HISTORY_SINCE_1877": {
      id: 9868,
      grade: null,
      courseType: "ALEVEL_US_HISTORY_SINCE_1877",
      chapterName: "The Gilded Age and Progressive Era",
      topic:
        "1.1 What were the impacts of rapid economic growth in the US during the Gilded Age?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.340+00:00",
      language: null,
    },
    "7-ALEVEL_US_HISTORY_TO_1877": {
      id: 9633,
      grade: null,
      courseType: "ALEVEL_US_HISTORY_TO_1877",
      chapterName: "The American Civil War and Reconstruction, 1846–77.",
      topic:
        "1.1 How and why did sectional divisions widen between 1846 and 1861, resulting in the \n American Civil War?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.336+00:00",
      language: null,
    },
    "8-ENGLISH": {
      id: 10287,
      grade: 8,
      courseType: "ENGLISH",
      chapterName: "SCHOOL LIFE & EDUCATION",
      topic: "School events and celebrations (sports, music, drama)",
      deletedOn: null,
      updatedAt: "2025-06-09T17:00:21.649+00:00",
      language: null,
    },
    "8-SCIENCE": {
      id: 2754,
      grade: 8,
      courseType: "SCIENCE",
      chapterName: "MEVSİMLER VE İKLİM",
      topic: "Mevsimlerin Oluşumu",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "8-HISTORY": {
      id: 2716,
      grade: 8,
      courseType: "HISTORY",
      chapterName: "1. ÜNİTE BİR KAHRAMAN DOĞUYOR",
      topic: "1. Avrupa'daki Gelişmeler Ve Osmanlı Devleti",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "8-TURKISH": {
      id: 2676,
      grade: 8,
      courseType: "TURKISH",
      chapterName: "ERDEMLER",
      topic: "İyimserlik Ve Kötümserlik Üzerine",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "8-DIGITAL_CITIZENSHIP": {
      id: 7336,
      grade: 8,
      courseType: "DIGITAL_CITIZENSHIP",
      chapterName: "Dijital Medya ve Beynimiz",
      topic: "Dijital Medya Ve Beynimiz",
      deletedOn: null,
      updatedAt: "2024-12-06T17:53:39.000+00:00",
      language: null,
    },
    "8-AP_ASTRONOMY": {
      id: 5186,
      grade: null,
      courseType: "AP_ASTRONOMY",
      chapterName: "Science and the Universe: A Brief Tour",
      topic: "Introduction",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "8-AP_PSYCHOLOGY": {
      id: 4184,
      grade: null,
      courseType: "AP_PSYCHOLOGY",
      chapterName: "Introduction to Psychology",
      topic: "What Is Psychology?",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "8-AP_BUSINESS": {
      id: 4910,
      grade: null,
      courseType: "AP_BUSINESS",
      chapterName: "Understanding Economic Systems and Business",
      topic: "The Nature Of Business",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "8-AP_ECONOMICS": {
      id: 5044,
      grade: null,
      courseType: "AP_ECONOMICS",
      chapterName: "Welcome to Economics!",
      topic: "What Is Economics, And Why Is It Important?",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "8-AP_SOCIOLOGY": {
      id: 4716,
      grade: null,
      courseType: "AP_SOCIOLOGY",
      chapterName: "An Introduction to Sociology",
      topic: "What Is Sociology?",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "8-AP_WORLD_HISTORY_1": {
      id: 3938,
      grade: null,
      courseType: "AP_WORLD_HISTORY_1",
      chapterName: "Understanding the Past",
      topic: "Introduction",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "8-AP_WORLD_HISTORY_2": {
      id: 4790,
      grade: null,
      courseType: "AP_WORLD_HISTORY_2",
      chapterName: "Understanding the Past",
      topic: "Introduction",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "8-AP_BIOLOGY": {
      id: 4017,
      grade: null,
      courseType: "AP_BIOLOGY",
      chapterName: "1: The Study of Life",
      topic: "1.1 The Science Of Biology",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "8-AP_CHEMISTRY": {
      id: 5371,
      grade: null,
      courseType: "AP_CHEMISTRY",
      chapterName: "1: Essential Ideas",
      topic: "1.1 Chemistry In Context",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "8-AP_PHYSICS": {
      id: 4272,
      grade: null,
      courseType: "AP_PHYSICS",
      chapterName: "Introduction: The Nature of Science and Physics",
      topic: "Connection For Ap® Courses",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "8-IGCSE_BIOLOGY": {
      id: 9089,
      grade: null,
      courseType: "IGCSE_BIOLOGY",
      chapterName: "Characteristics and classification of living organisms",
      topic: "1.1 Characteristics of living organisms",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.545+00:00",
      language: null,
    },
    "8-IGCSE_PHYSICS": {
      id: 9328,
      grade: null,
      courseType: "IGCSE_PHYSICS",
      chapterName: "Motion, forces and energy",
      topic: "1.1 Physical quantities and measurement techniques",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.547+00:00",
      language: null,
    },
    "8-IGCSE_CHEMISTRY": {
      id: 9252,
      grade: null,
      courseType: "IGCSE_CHEMISTRY",
      chapterName: "States of matter",
      topic: "1.1 Solids, liquids and gases",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.546+00:00",
      language: null,
    },
    "8-IGCSE_BUSINESS_STUDIES": {
      id: 9303,
      grade: null,
      courseType: "IGCSE_BUSINESS_STUDIES",
      chapterName: "Understanding business activity",
      topic: "1.1 Business activity",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.547+00:00",
      language: null,
    },
    "8-IGCSE_ECONOMICS": {
      id: 9153,
      grade: null,
      courseType: "IGCSE_ECONOMICS",
      chapterName: "The basic economic problem",
      topic: "1.1 The nature of the economic problem",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.545+00:00",
      language: null,
    },
    "8-IGCSE_COMPUTER_SCIENCE": {
      id: 9192,
      grade: null,
      courseType: "IGCSE_COMPUTER_SCIENCE",
      chapterName: "Data representation",
      topic: "1.1 Number systems",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.546+00:00",
      language: null,
    },
    "8-IGCSE_GEOGRAPHY": {
      id: 9070,
      grade: null,
      courseType: "IGCSE_GEOGRAPHY",
      chapterName: "Population and settlement",
      topic: "1.1 Population dynamics",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.544+00:00",
      language: null,
    },
    "8-IGCSE_HISTORY": {
      id: 9221,
      grade: null,
      courseType: "IGCSE_HISTORY",
      chapterName:
        "Core content: Option A: The nineteenth century: the development of modern nation states, 1848–1914",
      topic: "1 Were the revolutions of 1848 important?",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.546+00:00",
      language: null,
    },
    "8-IGCSE_MATHEMATICS": {
      id: 8997,
      grade: null,
      courseType: "IGCSE_MATHEMATICS",
      chapterName: "Number",
      topic: "C1.1 Types of number",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.544+00:00",
      language: null,
    },
    "8-IB_DP_GEOGRAPHY": {
      id: 9579,
      grade: null,
      courseType: "IB_DP_GEOGRAPHY",
      chapterName: "Geographic themes-seven options",
      topic: "Freshwater",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.168+00:00",
      language: null,
    },
    "8-IB_DP_BUSINESS_MANAGEMENT": {
      id: 9542,
      grade: null,
      courseType: "IB_DP_BUSINESS_MANAGEMENT",
      chapterName: "Unit 1: Introduction to business management",
      topic: "1.1 What is a business?",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "8-IB_DP_CHEMISTRY": {
      id: 9520,
      grade: null,
      courseType: "IB_DP_CHEMISTRY",
      chapterName: "Structure 1. Models of the particulate nature of matter",
      topic: "Structure 1.1-Introduction to the particulate nature of matter",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "8-IB_DP_BIOLOGY": {
      id: 9480,
      grade: null,
      courseType: "IB_DP_BIOLOGY",
      chapterName: "Unity and diversity",
      topic: "Water",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "8-IB_DP_ECONOMICS": {
      id: 9449,
      grade: null,
      courseType: "IB_DP_ECONOMICS",
      chapterName: "Unit 1: Introduction to economics",
      topic: "1.1 What is economics?",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "8-IB_DP_HISTORY": {
      id: 9427,
      grade: null,
      courseType: "IB_DP_HISTORY",
      chapterName: "Prescribed subjects",
      topic: "Military leaders",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "8-IB_DP_PHYSICS": {
      id: 9403,
      grade: null,
      courseType: "IB_DP_PHYSICS",
      chapterName: "A Space, time and motion",
      topic: "A.1 Kinematics •",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "8-IB_DP_COMPUTER_SCIENCE": {
      id: 9392,
      grade: null,
      courseType: "IB_DP_COMPUTER_SCIENCE",
      chapterName: "Topic 1: System fundamentals",
      topic: "Topic 1: System fundamentals",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "8-IB_DP_MATHEMATICS": {
      id: 9387,
      grade: null,
      courseType: "IB_DP_MATHEMATICS",
      chapterName: "Number and algebra",
      topic: "Number and algebra",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "8-ALEVEL_BIOLOGY": {
      id: 10115,
      grade: null,
      courseType: "ALEVEL_BIOLOGY",
      chapterName: "Cell structure (AS Level)",
      topic: "1.1 The microscope in cell\nstudies",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.343+00:00",
      language: null,
    },
    "8-ALEVEL_BUSSINESS": {
      id: 9832,
      grade: null,
      courseType: "ALEVEL_BUSSINESS",
      chapterName: "Business and its environment (AS Level)",
      topic: "1.1 Enterprise",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.340+00:00",
      language: null,
    },
    "8-ALEVEL_CHEMISTRY": {
      id: 9648,
      grade: null,
      courseType: "ALEVEL_CHEMISTRY",
      chapterName: "Atomic structure",
      topic: "1.1 Particles in the atom and atomic radius",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.337+00:00",
      language: null,
    },
    "8-ALEVEL_COMPUTER_SCIENCE": {
      id: 9750,
      grade: null,
      courseType: "ALEVEL_COMPUTER_SCIENCE",
      chapterName: "Information representation",
      topic: "1.1 Data Representation",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.338+00:00",
      language: null,
    },
    "8-ALEVEL_ECONOMICS": {
      id: 9883,
      grade: null,
      courseType: "ALEVEL_ECONOMICS",
      chapterName: "Basic economic ideas and resource allocation (AS Level)",
      topic: "1.1 Scarcity, choice and opportunity cost",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.340+00:00",
      language: null,
    },
    "8-ALEVEL_EUROPEAN_HISTORY": {
      id: 9725,
      grade: null,
      courseType: "ALEVEL_EUROPEAN_HISTORY",
      chapterName: "Modern Europe, 1774-1924: France, 1774–1814",
      topic:
        "1.1 What were the causes and immediate consequences of the 1789 Revolution?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.338+00:00",
      language: null,
    },
    "8-ALEVEL_FURTHER_MATHEMATICS": {
      id: 9937,
      grade: null,
      courseType: "ALEVEL_FURTHER_MATHEMATICS",
      chapterName: "Further Pure Mathematics 1 (for Paper 1)",
      topic: "1.1 Roots of polynomial equations",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.341+00:00",
      language: null,
    },
    "8-ALEVEL_GEOGRAPHY": {
      id: 10059,
      grade: null,
      courseType: "ALEVEL_GEOGRAPHY",
      chapterName: "Hydrology and fluvial geomorphology",
      topic: "1.1 The drainage basin system",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.342+00:00",
      language: null,
    },
    "8-ALEVEL_INTERNATIONAL_HISTORY": {
      id: 10035,
      grade: null,
      courseType: "ALEVEL_INTERNATIONAL_HISTORY",
      chapterName: "Imperialism and the emergence of world powers c.1870–1918",
      topic: "1.1 Why was imperialism a significant force in Africa from 1870?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.342+00:00",
      language: null,
    },
    "8-ALEVEL_MATHEMATICS": {
      id: 9794,
      grade: null,
      courseType: "ALEVEL_MATHEMATICS",
      chapterName: "Pure Mathematics 1 (for Paper 1)",
      topic: "1.1 Quadratics",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.339+00:00",
      language: null,
    },
    "8-ALEVEL_PHYSICS": {
      id: 9961,
      grade: null,
      courseType: "ALEVEL_PHYSICS",
      chapterName: "Physical quantities and units",
      topic: "1.1 Physical quantities",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.341+00:00",
      language: null,
    },
    "8-ALEVEL_SOCIOLOGY": {
      id: 9598,
      grade: null,
      courseType: "ALEVEL_SOCIOLOGY",
      chapterName: "Socialisation and the creation of social identity",
      topic: "1.1 The process of learning and socialisation",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.336+00:00",
      language: null,
    },
    "8-ALEVEL_US_HISTORY_SINCE_1877": {
      id: 9868,
      grade: null,
      courseType: "ALEVEL_US_HISTORY_SINCE_1877",
      chapterName: "The Gilded Age and Progressive Era",
      topic:
        "1.1 What were the impacts of rapid economic growth in the US during the Gilded Age?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.340+00:00",
      language: null,
    },
    "8-ALEVEL_US_HISTORY_TO_1877": {
      id: 9633,
      grade: null,
      courseType: "ALEVEL_US_HISTORY_TO_1877",
      chapterName: "The American Civil War and Reconstruction, 1846–77.",
      topic:
        "1.1 How and why did sectional divisions widen between 1846 and 1861, resulting in the \n American Civil War?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.336+00:00",
      language: null,
    },
    "9-HISTORY": {
      id: 7549,
      grade: 9,
      courseType: "HISTORY",
      chapterName: "1.Ünite: GEÇMİŞİN İNŞA SÜRECİNDE TARİH",
      topic: "1.1 Tarih Öğrenmenin Faydaları",
      deletedOn: null,
      updatedAt: "2024-12-06T13:18:42.646+00:00",
      language: null,
    },
    "9-GEOGRAPHY": {
      id: 7499,
      grade: 9,
      courseType: "GEOGRAPHY",
      chapterName: "1.Ünite: COĞRAFYANIN DOĞASI",
      topic: "1.1.1 Coğrafya Biliminin Konusu Ve Bölümleri",
      deletedOn: null,
      updatedAt: "2024-12-06T13:18:42.646+00:00",
      language: null,
    },
    "9-TURKISH": {
      id: 7408,
      grade: 9,
      courseType: "TURKISH",
      chapterName: "1.Tema: Sözün İnceliği",
      topic: "Okuma: Şiir",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "9-BIOLOGY": {
      id: 7562,
      grade: 9,
      courseType: "BIOLOGY",
      chapterName: "1.Tema Yaşam",
      topic: "Biyolojinin Tanımı Ve Önemi",
      deletedOn: null,
      updatedAt: "2024-12-06T13:18:42.646+00:00",
      language: null,
    },
    "9-CHEMISTRY": {
      id: 7479,
      grade: 9,
      courseType: "CHEMISTRY",
      chapterName: "1. Etkileşim",
      topic: "1.1.1 Günlük Hayatta Kimya",
      deletedOn: null,
      updatedAt: "2024-12-06T13:18:42.646+00:00",
      language: null,
    },
    "9-PHYSICS": {
      id: 7521,
      grade: 9,
      courseType: "PHYSICS",
      chapterName: "1.Ünite: FİZİK BİLİMİ VE KARİYER KEŞFİ",
      topic: "1.1 Fizik Bilimi",
      deletedOn: null,
      updatedAt: "2024-12-06T13:18:42.646+00:00",
      language: null,
    },
    "9-DIGITAL_CITIZENSHIP": {
      id: 7342,
      grade: 9,
      courseType: "DIGITAL_CITIZENSHIP",
      chapterName: "Dijital Hayatımız ... Gibi",
      topic: "Dijital Hayatımız ... Gibi",
      deletedOn: null,
      updatedAt: "2024-12-06T17:53:39.000+00:00",
      language: null,
    },
    "9-AP_ASTRONOMY": {
      id: 5186,
      grade: null,
      courseType: "AP_ASTRONOMY",
      chapterName: "Science and the Universe: A Brief Tour",
      topic: "Introduction",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "9-AP_PSYCHOLOGY": {
      id: 4184,
      grade: null,
      courseType: "AP_PSYCHOLOGY",
      chapterName: "Introduction to Psychology",
      topic: "What Is Psychology?",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "9-AP_BUSINESS": {
      id: 4910,
      grade: null,
      courseType: "AP_BUSINESS",
      chapterName: "Understanding Economic Systems and Business",
      topic: "The Nature Of Business",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "9-AP_ECONOMICS": {
      id: 5044,
      grade: null,
      courseType: "AP_ECONOMICS",
      chapterName: "Welcome to Economics!",
      topic: "What Is Economics, And Why Is It Important?",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "9-AP_SOCIOLOGY": {
      id: 4716,
      grade: null,
      courseType: "AP_SOCIOLOGY",
      chapterName: "An Introduction to Sociology",
      topic: "What Is Sociology?",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "9-AP_WORLD_HISTORY_1": {
      id: 3938,
      grade: null,
      courseType: "AP_WORLD_HISTORY_1",
      chapterName: "Understanding the Past",
      topic: "Introduction",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "9-AP_WORLD_HISTORY_2": {
      id: 4790,
      grade: null,
      courseType: "AP_WORLD_HISTORY_2",
      chapterName: "Understanding the Past",
      topic: "Introduction",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "9-AP_BIOLOGY": {
      id: 4017,
      grade: null,
      courseType: "AP_BIOLOGY",
      chapterName: "1: The Study of Life",
      topic: "1.1 The Science Of Biology",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "9-AP_CHEMISTRY": {
      id: 5371,
      grade: null,
      courseType: "AP_CHEMISTRY",
      chapterName: "1: Essential Ideas",
      topic: "1.1 Chemistry In Context",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "9-AP_PHYSICS": {
      id: 4272,
      grade: null,
      courseType: "AP_PHYSICS",
      chapterName: "Introduction: The Nature of Science and Physics",
      topic: "Connection For Ap® Courses",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "9-IGCSE_BIOLOGY": {
      id: 9089,
      grade: null,
      courseType: "IGCSE_BIOLOGY",
      chapterName: "Characteristics and classification of living organisms",
      topic: "1.1 Characteristics of living organisms",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.545+00:00",
      language: null,
    },
    "9-IGCSE_PHYSICS": {
      id: 9328,
      grade: null,
      courseType: "IGCSE_PHYSICS",
      chapterName: "Motion, forces and energy",
      topic: "1.1 Physical quantities and measurement techniques",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.547+00:00",
      language: null,
    },
    "9-IGCSE_CHEMISTRY": {
      id: 9252,
      grade: null,
      courseType: "IGCSE_CHEMISTRY",
      chapterName: "States of matter",
      topic: "1.1 Solids, liquids and gases",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.546+00:00",
      language: null,
    },
    "9-IGCSE_BUSINESS_STUDIES": {
      id: 9303,
      grade: null,
      courseType: "IGCSE_BUSINESS_STUDIES",
      chapterName: "Understanding business activity",
      topic: "1.1 Business activity",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.547+00:00",
      language: null,
    },
    "9-IGCSE_ECONOMICS": {
      id: 9153,
      grade: null,
      courseType: "IGCSE_ECONOMICS",
      chapterName: "The basic economic problem",
      topic: "1.1 The nature of the economic problem",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.545+00:00",
      language: null,
    },
    "9-IGCSE_COMPUTER_SCIENCE": {
      id: 9192,
      grade: null,
      courseType: "IGCSE_COMPUTER_SCIENCE",
      chapterName: "Data representation",
      topic: "1.1 Number systems",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.546+00:00",
      language: null,
    },
    "9-IGCSE_GEOGRAPHY": {
      id: 9070,
      grade: null,
      courseType: "IGCSE_GEOGRAPHY",
      chapterName: "Population and settlement",
      topic: "1.1 Population dynamics",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.544+00:00",
      language: null,
    },
    "9-IGCSE_HISTORY": {
      id: 9221,
      grade: null,
      courseType: "IGCSE_HISTORY",
      chapterName:
        "Core content: Option A: The nineteenth century: the development of modern nation states, 1848–1914",
      topic: "1 Were the revolutions of 1848 important?",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.546+00:00",
      language: null,
    },
    "9-IGCSE_MATHEMATICS": {
      id: 8997,
      grade: null,
      courseType: "IGCSE_MATHEMATICS",
      chapterName: "Number",
      topic: "C1.1 Types of number",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.544+00:00",
      language: null,
    },
    "9-IB_DP_GEOGRAPHY": {
      id: 9579,
      grade: null,
      courseType: "IB_DP_GEOGRAPHY",
      chapterName: "Geographic themes-seven options",
      topic: "Freshwater",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.168+00:00",
      language: null,
    },
    "9-IB_DP_BUSINESS_MANAGEMENT": {
      id: 9542,
      grade: null,
      courseType: "IB_DP_BUSINESS_MANAGEMENT",
      chapterName: "Unit 1: Introduction to business management",
      topic: "1.1 What is a business?",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "9-IB_DP_CHEMISTRY": {
      id: 9520,
      grade: null,
      courseType: "IB_DP_CHEMISTRY",
      chapterName: "Structure 1. Models of the particulate nature of matter",
      topic: "Structure 1.1-Introduction to the particulate nature of matter",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "9-IB_DP_BIOLOGY": {
      id: 9480,
      grade: null,
      courseType: "IB_DP_BIOLOGY",
      chapterName: "Unity and diversity",
      topic: "Water",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "9-IB_DP_ECONOMICS": {
      id: 9449,
      grade: null,
      courseType: "IB_DP_ECONOMICS",
      chapterName: "Unit 1: Introduction to economics",
      topic: "1.1 What is economics?",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "9-IB_DP_HISTORY": {
      id: 9427,
      grade: null,
      courseType: "IB_DP_HISTORY",
      chapterName: "Prescribed subjects",
      topic: "Military leaders",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "9-IB_DP_PHYSICS": {
      id: 9403,
      grade: null,
      courseType: "IB_DP_PHYSICS",
      chapterName: "A Space, time and motion",
      topic: "A.1 Kinematics •",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "9-IB_DP_COMPUTER_SCIENCE": {
      id: 9392,
      grade: null,
      courseType: "IB_DP_COMPUTER_SCIENCE",
      chapterName: "Topic 1: System fundamentals",
      topic: "Topic 1: System fundamentals",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "9-IB_DP_MATHEMATICS": {
      id: 9387,
      grade: null,
      courseType: "IB_DP_MATHEMATICS",
      chapterName: "Number and algebra",
      topic: "Number and algebra",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "9-ALEVEL_BIOLOGY": {
      id: 10115,
      grade: null,
      courseType: "ALEVEL_BIOLOGY",
      chapterName: "Cell structure (AS Level)",
      topic: "1.1 The microscope in cell\nstudies",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.343+00:00",
      language: null,
    },
    "9-ALEVEL_BUSSINESS": {
      id: 9832,
      grade: null,
      courseType: "ALEVEL_BUSSINESS",
      chapterName: "Business and its environment (AS Level)",
      topic: "1.1 Enterprise",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.340+00:00",
      language: null,
    },
    "9-ALEVEL_CHEMISTRY": {
      id: 9648,
      grade: null,
      courseType: "ALEVEL_CHEMISTRY",
      chapterName: "Atomic structure",
      topic: "1.1 Particles in the atom and atomic radius",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.337+00:00",
      language: null,
    },
    "9-ALEVEL_COMPUTER_SCIENCE": {
      id: 9750,
      grade: null,
      courseType: "ALEVEL_COMPUTER_SCIENCE",
      chapterName: "Information representation",
      topic: "1.1 Data Representation",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.338+00:00",
      language: null,
    },
    "9-ALEVEL_ECONOMICS": {
      id: 9883,
      grade: null,
      courseType: "ALEVEL_ECONOMICS",
      chapterName: "Basic economic ideas and resource allocation (AS Level)",
      topic: "1.1 Scarcity, choice and opportunity cost",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.340+00:00",
      language: null,
    },
    "9-ALEVEL_EUROPEAN_HISTORY": {
      id: 9725,
      grade: null,
      courseType: "ALEVEL_EUROPEAN_HISTORY",
      chapterName: "Modern Europe, 1774-1924: France, 1774–1814",
      topic:
        "1.1 What were the causes and immediate consequences of the 1789 Revolution?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.338+00:00",
      language: null,
    },
    "9-ALEVEL_FURTHER_MATHEMATICS": {
      id: 9937,
      grade: null,
      courseType: "ALEVEL_FURTHER_MATHEMATICS",
      chapterName: "Further Pure Mathematics 1 (for Paper 1)",
      topic: "1.1 Roots of polynomial equations",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.341+00:00",
      language: null,
    },
    "9-ALEVEL_GEOGRAPHY": {
      id: 10059,
      grade: null,
      courseType: "ALEVEL_GEOGRAPHY",
      chapterName: "Hydrology and fluvial geomorphology",
      topic: "1.1 The drainage basin system",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.342+00:00",
      language: null,
    },
    "9-ALEVEL_INTERNATIONAL_HISTORY": {
      id: 10035,
      grade: null,
      courseType: "ALEVEL_INTERNATIONAL_HISTORY",
      chapterName: "Imperialism and the emergence of world powers c.1870–1918",
      topic: "1.1 Why was imperialism a significant force in Africa from 1870?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.342+00:00",
      language: null,
    },
    "9-ALEVEL_MATHEMATICS": {
      id: 9794,
      grade: null,
      courseType: "ALEVEL_MATHEMATICS",
      chapterName: "Pure Mathematics 1 (for Paper 1)",
      topic: "1.1 Quadratics",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.339+00:00",
      language: null,
    },
    "9-ALEVEL_PHYSICS": {
      id: 9961,
      grade: null,
      courseType: "ALEVEL_PHYSICS",
      chapterName: "Physical quantities and units",
      topic: "1.1 Physical quantities",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.341+00:00",
      language: null,
    },
    "9-ALEVEL_SOCIOLOGY": {
      id: 9598,
      grade: null,
      courseType: "ALEVEL_SOCIOLOGY",
      chapterName: "Socialisation and the creation of social identity",
      topic: "1.1 The process of learning and socialisation",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.336+00:00",
      language: null,
    },
    "9-ALEVEL_US_HISTORY_SINCE_1877": {
      id: 9868,
      grade: null,
      courseType: "ALEVEL_US_HISTORY_SINCE_1877",
      chapterName: "The Gilded Age and Progressive Era",
      topic:
        "1.1 What were the impacts of rapid economic growth in the US during the Gilded Age?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.340+00:00",
      language: null,
    },
    "9-ALEVEL_US_HISTORY_TO_1877": {
      id: 9633,
      grade: null,
      courseType: "ALEVEL_US_HISTORY_TO_1877",
      chapterName: "The American Civil War and Reconstruction, 1846–77.",
      topic:
        "1.1 How and why did sectional divisions widen between 1846 and 1861, resulting in the \n American Civil War?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.336+00:00",
      language: null,
    },
    "10-HISTORY": {
      id: 3399,
      grade: 10,
      courseType: "HISTORY",
      chapterName:
        "1. ÜNİTE: YERLEŞME VE DEVLETLEŞME SÜRECİNDE SELÇUKLU TÜRKİYESİ",
      topic: "Anadolu Siyasi Tarihi (1072-1308)",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "10-GEOGRAPHY": {
      id: 3269,
      grade: 10,
      courseType: "GEOGRAPHY",
      chapterName: "1. ÜNİTE:  DOĞAL SİSTEMLER",
      topic: "Dünya'nin Tektonik Oluşumu",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "10-TURKISH": {
      id: 3550,
      grade: 10,
      courseType: "TURKISH",
      chapterName: "1. ÜNİTE: TÜRK DİLİ EDEBİYATINA GİRİŞ",
      topic: "Okuma",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "10-BIOLOGY": {
      id: 2980,
      grade: 10,
      courseType: "BIOLOGY",
      chapterName: "1. ÜNİTE: HÜCRE BÖLÜNMELERİ",
      topic: "Mitoz Ve Eşeysiz Üreme",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "10-CHEMISTRY": {
      id: 3151,
      grade: 10,
      courseType: "CHEMISTRY",
      chapterName: "1. ÜNİTE",
      topic: "Kimyanın Temel Kanunları Ve Kimyasal Hesaplamalar",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "10-PHYSICS": {
      id: 3784,
      grade: 10,
      courseType: "PHYSICS",
      chapterName: "1. ÜNİTE: ELEKTRİK VE MANYETİZMA",
      topic: "Elektrik Akımı, Potansiyel Farkı Ve Direnç",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "10-PHILOSOPHY": {
      id: 3473,
      grade: 10,
      courseType: "PHILOSOPHY",
      chapterName: "1. ÜNİTE: FELSEFE İLE DÜŞÜNME",
      topic: "Felsefenin Anlamı",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "10-DIGITAL_CITIZENSHIP": {
      id: 7348,
      grade: 10,
      courseType: "DIGITAL_CITIZENSHIP",
      chapterName: "Sosyal Medya ve Hislerimiz",
      topic: "Sosyal Medya Ve Hislerimiz",
      deletedOn: null,
      updatedAt: "2024-12-06T17:53:39.000+00:00",
      language: null,
    },
    "10-AP_ASTRONOMY": {
      id: 5186,
      grade: null,
      courseType: "AP_ASTRONOMY",
      chapterName: "Science and the Universe: A Brief Tour",
      topic: "Introduction",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "10-AP_PSYCHOLOGY": {
      id: 4184,
      grade: null,
      courseType: "AP_PSYCHOLOGY",
      chapterName: "Introduction to Psychology",
      topic: "What Is Psychology?",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "10-AP_BUSINESS": {
      id: 4910,
      grade: null,
      courseType: "AP_BUSINESS",
      chapterName: "Understanding Economic Systems and Business",
      topic: "The Nature Of Business",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "10-AP_ECONOMICS": {
      id: 5044,
      grade: null,
      courseType: "AP_ECONOMICS",
      chapterName: "Welcome to Economics!",
      topic: "What Is Economics, And Why Is It Important?",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "10-AP_SOCIOLOGY": {
      id: 4716,
      grade: null,
      courseType: "AP_SOCIOLOGY",
      chapterName: "An Introduction to Sociology",
      topic: "What Is Sociology?",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "10-AP_WORLD_HISTORY_1": {
      id: 3938,
      grade: null,
      courseType: "AP_WORLD_HISTORY_1",
      chapterName: "Understanding the Past",
      topic: "Introduction",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "10-AP_WORLD_HISTORY_2": {
      id: 4790,
      grade: null,
      courseType: "AP_WORLD_HISTORY_2",
      chapterName: "Understanding the Past",
      topic: "Introduction",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "10-AP_BIOLOGY": {
      id: 4017,
      grade: null,
      courseType: "AP_BIOLOGY",
      chapterName: "1: The Study of Life",
      topic: "1.1 The Science Of Biology",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "10-AP_CHEMISTRY": {
      id: 5371,
      grade: null,
      courseType: "AP_CHEMISTRY",
      chapterName: "1: Essential Ideas",
      topic: "1.1 Chemistry In Context",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "10-AP_PHYSICS": {
      id: 4272,
      grade: null,
      courseType: "AP_PHYSICS",
      chapterName: "Introduction: The Nature of Science and Physics",
      topic: "Connection For Ap® Courses",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "10-IGCSE_BIOLOGY": {
      id: 9089,
      grade: null,
      courseType: "IGCSE_BIOLOGY",
      chapterName: "Characteristics and classification of living organisms",
      topic: "1.1 Characteristics of living organisms",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.545+00:00",
      language: null,
    },
    "10-IGCSE_PHYSICS": {
      id: 9328,
      grade: null,
      courseType: "IGCSE_PHYSICS",
      chapterName: "Motion, forces and energy",
      topic: "1.1 Physical quantities and measurement techniques",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.547+00:00",
      language: null,
    },
    "10-IGCSE_CHEMISTRY": {
      id: 9252,
      grade: null,
      courseType: "IGCSE_CHEMISTRY",
      chapterName: "States of matter",
      topic: "1.1 Solids, liquids and gases",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.546+00:00",
      language: null,
    },
    "10-IGCSE_BUSINESS_STUDIES": {
      id: 9303,
      grade: null,
      courseType: "IGCSE_BUSINESS_STUDIES",
      chapterName: "Understanding business activity",
      topic: "1.1 Business activity",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.547+00:00",
      language: null,
    },
    "10-IGCSE_ECONOMICS": {
      id: 9153,
      grade: null,
      courseType: "IGCSE_ECONOMICS",
      chapterName: "The basic economic problem",
      topic: "1.1 The nature of the economic problem",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.545+00:00",
      language: null,
    },
    "10-IGCSE_COMPUTER_SCIENCE": {
      id: 9192,
      grade: null,
      courseType: "IGCSE_COMPUTER_SCIENCE",
      chapterName: "Data representation",
      topic: "1.1 Number systems",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.546+00:00",
      language: null,
    },
    "10-IGCSE_GEOGRAPHY": {
      id: 9070,
      grade: null,
      courseType: "IGCSE_GEOGRAPHY",
      chapterName: "Population and settlement",
      topic: "1.1 Population dynamics",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.544+00:00",
      language: null,
    },
    "10-IGCSE_HISTORY": {
      id: 9221,
      grade: null,
      courseType: "IGCSE_HISTORY",
      chapterName:
        "Core content: Option A: The nineteenth century: the development of modern nation states, 1848–1914",
      topic: "1 Were the revolutions of 1848 important?",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.546+00:00",
      language: null,
    },
    "10-IGCSE_MATHEMATICS": {
      id: 8997,
      grade: null,
      courseType: "IGCSE_MATHEMATICS",
      chapterName: "Number",
      topic: "C1.1 Types of number",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.544+00:00",
      language: null,
    },
    "10-IB_DP_GEOGRAPHY": {
      id: 9579,
      grade: null,
      courseType: "IB_DP_GEOGRAPHY",
      chapterName: "Geographic themes-seven options",
      topic: "Freshwater",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.168+00:00",
      language: null,
    },
    "10-IB_DP_BUSINESS_MANAGEMENT": {
      id: 9542,
      grade: null,
      courseType: "IB_DP_BUSINESS_MANAGEMENT",
      chapterName: "Unit 1: Introduction to business management",
      topic: "1.1 What is a business?",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "10-IB_DP_CHEMISTRY": {
      id: 9520,
      grade: null,
      courseType: "IB_DP_CHEMISTRY",
      chapterName: "Structure 1. Models of the particulate nature of matter",
      topic: "Structure 1.1-Introduction to the particulate nature of matter",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "10-IB_DP_BIOLOGY": {
      id: 9480,
      grade: null,
      courseType: "IB_DP_BIOLOGY",
      chapterName: "Unity and diversity",
      topic: "Water",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "10-IB_DP_ECONOMICS": {
      id: 9449,
      grade: null,
      courseType: "IB_DP_ECONOMICS",
      chapterName: "Unit 1: Introduction to economics",
      topic: "1.1 What is economics?",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "10-IB_DP_HISTORY": {
      id: 9427,
      grade: null,
      courseType: "IB_DP_HISTORY",
      chapterName: "Prescribed subjects",
      topic: "Military leaders",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "10-IB_DP_PHYSICS": {
      id: 9403,
      grade: null,
      courseType: "IB_DP_PHYSICS",
      chapterName: "A Space, time and motion",
      topic: "A.1 Kinematics •",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "10-IB_DP_COMPUTER_SCIENCE": {
      id: 9392,
      grade: null,
      courseType: "IB_DP_COMPUTER_SCIENCE",
      chapterName: "Topic 1: System fundamentals",
      topic: "Topic 1: System fundamentals",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "10-IB_DP_MATHEMATICS": {
      id: 9387,
      grade: null,
      courseType: "IB_DP_MATHEMATICS",
      chapterName: "Number and algebra",
      topic: "Number and algebra",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "10-ALEVEL_BIOLOGY": {
      id: 10115,
      grade: null,
      courseType: "ALEVEL_BIOLOGY",
      chapterName: "Cell structure (AS Level)",
      topic: "1.1 The microscope in cell\nstudies",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.343+00:00",
      language: null,
    },
    "10-ALEVEL_BUSSINESS": {
      id: 9832,
      grade: null,
      courseType: "ALEVEL_BUSSINESS",
      chapterName: "Business and its environment (AS Level)",
      topic: "1.1 Enterprise",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.340+00:00",
      language: null,
    },
    "10-ALEVEL_CHEMISTRY": {
      id: 9648,
      grade: null,
      courseType: "ALEVEL_CHEMISTRY",
      chapterName: "Atomic structure",
      topic: "1.1 Particles in the atom and atomic radius",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.337+00:00",
      language: null,
    },
    "10-ALEVEL_COMPUTER_SCIENCE": {
      id: 9750,
      grade: null,
      courseType: "ALEVEL_COMPUTER_SCIENCE",
      chapterName: "Information representation",
      topic: "1.1 Data Representation",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.338+00:00",
      language: null,
    },
    "10-ALEVEL_ECONOMICS": {
      id: 9883,
      grade: null,
      courseType: "ALEVEL_ECONOMICS",
      chapterName: "Basic economic ideas and resource allocation (AS Level)",
      topic: "1.1 Scarcity, choice and opportunity cost",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.340+00:00",
      language: null,
    },
    "10-ALEVEL_EUROPEAN_HISTORY": {
      id: 9725,
      grade: null,
      courseType: "ALEVEL_EUROPEAN_HISTORY",
      chapterName: "Modern Europe, 1774-1924: France, 1774–1814",
      topic:
        "1.1 What were the causes and immediate consequences of the 1789 Revolution?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.338+00:00",
      language: null,
    },
    "10-ALEVEL_FURTHER_MATHEMATICS": {
      id: 9937,
      grade: null,
      courseType: "ALEVEL_FURTHER_MATHEMATICS",
      chapterName: "Further Pure Mathematics 1 (for Paper 1)",
      topic: "1.1 Roots of polynomial equations",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.341+00:00",
      language: null,
    },
    "10-ALEVEL_GEOGRAPHY": {
      id: 10059,
      grade: null,
      courseType: "ALEVEL_GEOGRAPHY",
      chapterName: "Hydrology and fluvial geomorphology",
      topic: "1.1 The drainage basin system",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.342+00:00",
      language: null,
    },
    "10-ALEVEL_INTERNATIONAL_HISTORY": {
      id: 10035,
      grade: null,
      courseType: "ALEVEL_INTERNATIONAL_HISTORY",
      chapterName: "Imperialism and the emergence of world powers c.1870–1918",
      topic: "1.1 Why was imperialism a significant force in Africa from 1870?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.342+00:00",
      language: null,
    },
    "10-ALEVEL_MATHEMATICS": {
      id: 9794,
      grade: null,
      courseType: "ALEVEL_MATHEMATICS",
      chapterName: "Pure Mathematics 1 (for Paper 1)",
      topic: "1.1 Quadratics",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.339+00:00",
      language: null,
    },
    "10-ALEVEL_PHYSICS": {
      id: 9961,
      grade: null,
      courseType: "ALEVEL_PHYSICS",
      chapterName: "Physical quantities and units",
      topic: "1.1 Physical quantities",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.341+00:00",
      language: null,
    },
    "10-ALEVEL_SOCIOLOGY": {
      id: 9598,
      grade: null,
      courseType: "ALEVEL_SOCIOLOGY",
      chapterName: "Socialisation and the creation of social identity",
      topic: "1.1 The process of learning and socialisation",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.336+00:00",
      language: null,
    },
    "10-ALEVEL_US_HISTORY_SINCE_1877": {
      id: 9868,
      grade: null,
      courseType: "ALEVEL_US_HISTORY_SINCE_1877",
      chapterName: "The Gilded Age and Progressive Era",
      topic:
        "1.1 What were the impacts of rapid economic growth in the US during the Gilded Age?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.340+00:00",
      language: null,
    },
    "10-ALEVEL_US_HISTORY_TO_1877": {
      id: 9633,
      grade: null,
      courseType: "ALEVEL_US_HISTORY_TO_1877",
      chapterName: "The American Civil War and Reconstruction, 1846–77.",
      topic:
        "1.1 How and why did sectional divisions widen between 1846 and 1861, resulting in the \n American Civil War?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.336+00:00",
      language: null,
    },
    "11-HISTORY": {
      id: 3428,
      grade: 11,
      courseType: "HISTORY",
      chapterName:
        "1. ÜNİTE: DEĞİŞEN DÜNYA DENGELERİ KARŞISINDA OSMANLI SİYASETİ (1595-1774)",
      topic: "1595-1700 Yılları Arasındaki Siyasi Gelişmeler",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "11-GEOGRAPHY": {
      id: 3298,
      grade: 11,
      courseType: "GEOGRAPHY",
      chapterName: "1. ÜNİTE: DOĞAL SİSTEMLER",
      topic: "Yeryüzünde Biyoçeşitlilik",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "11-TURKISH": {
      id: 3578,
      grade: 11,
      courseType: "TURKISH",
      chapterName: "1. ÜNİTE: GİRİŞ",
      topic: "Okuma Çalışmaları",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "11-BIOLOGY": {
      id: 3009,
      grade: 11,
      courseType: "BIOLOGY",
      chapterName: "1. ÜNİTE: İNSAN FİZYOLOJİSİ",
      topic: "Denetleyici Ve Düzenleyici Sistem, Duyu Organları",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "11-CHEMISTRY": {
      id: 3187,
      grade: 11,
      courseType: "CHEMISTRY",
      chapterName: "1. ÜNİTE: MODERN ATOM TEORİSİ",
      topic: "Bölüm: Atomun Kuantum Modeli",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "11-PHYSICS": {
      id: 3804,
      grade: 11,
      courseType: "PHYSICS",
      chapterName: "1. ÜNİTE: KUVVET VE HAREKET",
      topic: "Vektörler",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "11-PHILOSOPHY": {
      id: 3491,
      grade: 11,
      courseType: "PHILOSOPHY",
      chapterName: "1. ÜNİTE: MÖ 6. YÜZYIL-MS 2. YÜZYIL FELSEFESİ",
      topic: "Felsefenin Ortaya Çıkışı",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "11-DIGITAL_CITIZENSHIP": {
      id: 7354,
      grade: 11,
      courseType: "DIGITAL_CITIZENSHIP",
      chapterName: "Sosyal Medya ve Kişisel Veriler: Dengeyi Bulmak",
      topic: "Sosyal Medya Ve Kişisel Veriler: Dengeyi Bulmak",
      deletedOn: null,
      updatedAt: "2024-12-06T17:53:39.000+00:00",
      language: null,
    },
    "11-AP_ASTRONOMY": {
      id: 5186,
      grade: null,
      courseType: "AP_ASTRONOMY",
      chapterName: "Science and the Universe: A Brief Tour",
      topic: "Introduction",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "11-AP_PSYCHOLOGY": {
      id: 4184,
      grade: null,
      courseType: "AP_PSYCHOLOGY",
      chapterName: "Introduction to Psychology",
      topic: "What Is Psychology?",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "11-AP_BUSINESS": {
      id: 4910,
      grade: null,
      courseType: "AP_BUSINESS",
      chapterName: "Understanding Economic Systems and Business",
      topic: "The Nature Of Business",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "11-AP_ECONOMICS": {
      id: 5044,
      grade: null,
      courseType: "AP_ECONOMICS",
      chapterName: "Welcome to Economics!",
      topic: "What Is Economics, And Why Is It Important?",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "11-AP_SOCIOLOGY": {
      id: 4716,
      grade: null,
      courseType: "AP_SOCIOLOGY",
      chapterName: "An Introduction to Sociology",
      topic: "What Is Sociology?",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "11-AP_WORLD_HISTORY_1": {
      id: 3938,
      grade: null,
      courseType: "AP_WORLD_HISTORY_1",
      chapterName: "Understanding the Past",
      topic: "Introduction",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "11-AP_WORLD_HISTORY_2": {
      id: 4790,
      grade: null,
      courseType: "AP_WORLD_HISTORY_2",
      chapterName: "Understanding the Past",
      topic: "Introduction",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "11-AP_BIOLOGY": {
      id: 4017,
      grade: null,
      courseType: "AP_BIOLOGY",
      chapterName: "1: The Study of Life",
      topic: "1.1 The Science Of Biology",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "11-AP_CHEMISTRY": {
      id: 5371,
      grade: null,
      courseType: "AP_CHEMISTRY",
      chapterName: "1: Essential Ideas",
      topic: "1.1 Chemistry In Context",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "11-AP_PHYSICS": {
      id: 4272,
      grade: null,
      courseType: "AP_PHYSICS",
      chapterName: "Introduction: The Nature of Science and Physics",
      topic: "Connection For Ap® Courses",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "11-IGCSE_BIOLOGY": {
      id: 9089,
      grade: null,
      courseType: "IGCSE_BIOLOGY",
      chapterName: "Characteristics and classification of living organisms",
      topic: "1.1 Characteristics of living organisms",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.545+00:00",
      language: null,
    },
    "11-IGCSE_PHYSICS": {
      id: 9328,
      grade: null,
      courseType: "IGCSE_PHYSICS",
      chapterName: "Motion, forces and energy",
      topic: "1.1 Physical quantities and measurement techniques",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.547+00:00",
      language: null,
    },
    "11-IGCSE_CHEMISTRY": {
      id: 9252,
      grade: null,
      courseType: "IGCSE_CHEMISTRY",
      chapterName: "States of matter",
      topic: "1.1 Solids, liquids and gases",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.546+00:00",
      language: null,
    },
    "11-IGCSE_BUSINESS_STUDIES": {
      id: 9303,
      grade: null,
      courseType: "IGCSE_BUSINESS_STUDIES",
      chapterName: "Understanding business activity",
      topic: "1.1 Business activity",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.547+00:00",
      language: null,
    },
    "11-IGCSE_ECONOMICS": {
      id: 9153,
      grade: null,
      courseType: "IGCSE_ECONOMICS",
      chapterName: "The basic economic problem",
      topic: "1.1 The nature of the economic problem",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.545+00:00",
      language: null,
    },
    "11-IGCSE_COMPUTER_SCIENCE": {
      id: 9192,
      grade: null,
      courseType: "IGCSE_COMPUTER_SCIENCE",
      chapterName: "Data representation",
      topic: "1.1 Number systems",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.546+00:00",
      language: null,
    },
    "11-IGCSE_GEOGRAPHY": {
      id: 9070,
      grade: null,
      courseType: "IGCSE_GEOGRAPHY",
      chapterName: "Population and settlement",
      topic: "1.1 Population dynamics",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.544+00:00",
      language: null,
    },
    "11-IGCSE_HISTORY": {
      id: 9221,
      grade: null,
      courseType: "IGCSE_HISTORY",
      chapterName:
        "Core content: Option A: The nineteenth century: the development of modern nation states, 1848–1914",
      topic: "1 Were the revolutions of 1848 important?",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.546+00:00",
      language: null,
    },
    "11-IGCSE_MATHEMATICS": {
      id: 8997,
      grade: null,
      courseType: "IGCSE_MATHEMATICS",
      chapterName: "Number",
      topic: "C1.1 Types of number",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.544+00:00",
      language: null,
    },
    "11-IB_DP_GEOGRAPHY": {
      id: 9579,
      grade: null,
      courseType: "IB_DP_GEOGRAPHY",
      chapterName: "Geographic themes-seven options",
      topic: "Freshwater",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.168+00:00",
      language: null,
    },
    "11-IB_DP_BUSINESS_MANAGEMENT": {
      id: 9542,
      grade: null,
      courseType: "IB_DP_BUSINESS_MANAGEMENT",
      chapterName: "Unit 1: Introduction to business management",
      topic: "1.1 What is a business?",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "11-IB_DP_CHEMISTRY": {
      id: 9520,
      grade: null,
      courseType: "IB_DP_CHEMISTRY",
      chapterName: "Structure 1. Models of the particulate nature of matter",
      topic: "Structure 1.1-Introduction to the particulate nature of matter",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "11-IB_DP_BIOLOGY": {
      id: 9480,
      grade: null,
      courseType: "IB_DP_BIOLOGY",
      chapterName: "Unity and diversity",
      topic: "Water",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "11-IB_DP_ECONOMICS": {
      id: 9449,
      grade: null,
      courseType: "IB_DP_ECONOMICS",
      chapterName: "Unit 1: Introduction to economics",
      topic: "1.1 What is economics?",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "11-IB_DP_HISTORY": {
      id: 9427,
      grade: null,
      courseType: "IB_DP_HISTORY",
      chapterName: "Prescribed subjects",
      topic: "Military leaders",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "11-IB_DP_PHYSICS": {
      id: 9403,
      grade: null,
      courseType: "IB_DP_PHYSICS",
      chapterName: "A Space, time and motion",
      topic: "A.1 Kinematics •",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "11-IB_DP_COMPUTER_SCIENCE": {
      id: 9392,
      grade: null,
      courseType: "IB_DP_COMPUTER_SCIENCE",
      chapterName: "Topic 1: System fundamentals",
      topic: "Topic 1: System fundamentals",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "11-IB_DP_MATHEMATICS": {
      id: 9387,
      grade: null,
      courseType: "IB_DP_MATHEMATICS",
      chapterName: "Number and algebra",
      topic: "Number and algebra",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "11-ALEVEL_BIOLOGY": {
      id: 10115,
      grade: null,
      courseType: "ALEVEL_BIOLOGY",
      chapterName: "Cell structure (AS Level)",
      topic: "1.1 The microscope in cell\nstudies",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.343+00:00",
      language: null,
    },
    "11-ALEVEL_BUSSINESS": {
      id: 9832,
      grade: null,
      courseType: "ALEVEL_BUSSINESS",
      chapterName: "Business and its environment (AS Level)",
      topic: "1.1 Enterprise",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.340+00:00",
      language: null,
    },
    "11-ALEVEL_CHEMISTRY": {
      id: 9648,
      grade: null,
      courseType: "ALEVEL_CHEMISTRY",
      chapterName: "Atomic structure",
      topic: "1.1 Particles in the atom and atomic radius",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.337+00:00",
      language: null,
    },
    "11-ALEVEL_COMPUTER_SCIENCE": {
      id: 9750,
      grade: null,
      courseType: "ALEVEL_COMPUTER_SCIENCE",
      chapterName: "Information representation",
      topic: "1.1 Data Representation",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.338+00:00",
      language: null,
    },
    "11-ALEVEL_ECONOMICS": {
      id: 9883,
      grade: null,
      courseType: "ALEVEL_ECONOMICS",
      chapterName: "Basic economic ideas and resource allocation (AS Level)",
      topic: "1.1 Scarcity, choice and opportunity cost",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.340+00:00",
      language: null,
    },
    "11-ALEVEL_EUROPEAN_HISTORY": {
      id: 9725,
      grade: null,
      courseType: "ALEVEL_EUROPEAN_HISTORY",
      chapterName: "Modern Europe, 1774-1924: France, 1774–1814",
      topic:
        "1.1 What were the causes and immediate consequences of the 1789 Revolution?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.338+00:00",
      language: null,
    },
    "11-ALEVEL_FURTHER_MATHEMATICS": {
      id: 9937,
      grade: null,
      courseType: "ALEVEL_FURTHER_MATHEMATICS",
      chapterName: "Further Pure Mathematics 1 (for Paper 1)",
      topic: "1.1 Roots of polynomial equations",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.341+00:00",
      language: null,
    },
    "11-ALEVEL_GEOGRAPHY": {
      id: 10059,
      grade: null,
      courseType: "ALEVEL_GEOGRAPHY",
      chapterName: "Hydrology and fluvial geomorphology",
      topic: "1.1 The drainage basin system",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.342+00:00",
      language: null,
    },
    "11-ALEVEL_INTERNATIONAL_HISTORY": {
      id: 10035,
      grade: null,
      courseType: "ALEVEL_INTERNATIONAL_HISTORY",
      chapterName: "Imperialism and the emergence of world powers c.1870–1918",
      topic: "1.1 Why was imperialism a significant force in Africa from 1870?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.342+00:00",
      language: null,
    },
    "11-ALEVEL_MATHEMATICS": {
      id: 9794,
      grade: null,
      courseType: "ALEVEL_MATHEMATICS",
      chapterName: "Pure Mathematics 1 (for Paper 1)",
      topic: "1.1 Quadratics",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.339+00:00",
      language: null,
    },
    "11-ALEVEL_PHYSICS": {
      id: 9961,
      grade: null,
      courseType: "ALEVEL_PHYSICS",
      chapterName: "Physical quantities and units",
      topic: "1.1 Physical quantities",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.341+00:00",
      language: null,
    },
    "11-ALEVEL_SOCIOLOGY": {
      id: 9598,
      grade: null,
      courseType: "ALEVEL_SOCIOLOGY",
      chapterName: "Socialisation and the creation of social identity",
      topic: "1.1 The process of learning and socialisation",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.336+00:00",
      language: null,
    },
    "11-ALEVEL_US_HISTORY_SINCE_1877": {
      id: 9868,
      grade: null,
      courseType: "ALEVEL_US_HISTORY_SINCE_1877",
      chapterName: "The Gilded Age and Progressive Era",
      topic:
        "1.1 What were the impacts of rapid economic growth in the US during the Gilded Age?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.340+00:00",
      language: null,
    },
    "11-ALEVEL_US_HISTORY_TO_1877": {
      id: 9633,
      grade: null,
      courseType: "ALEVEL_US_HISTORY_TO_1877",
      chapterName: "The American Civil War and Reconstruction, 1846–77.",
      topic:
        "1.1 How and why did sectional divisions widen between 1846 and 1861, resulting in the \n American Civil War?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.336+00:00",
      language: null,
    },
    "12-HISTORY": {
      id: 3444,
      grade: 12,
      courseType: "HISTORY",
      chapterName: "1. ÜNİTE: XX. YÜZYIL BAŞLARINDA OSMANLI DEVLETİ VE DÜNYA",
      topic: "Mustafa Kemal'in Eğitim Ve Askerlik Hayatı",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "12-GEOGRAPHY": {
      id: 3338,
      grade: 12,
      courseType: "GEOGRAPHY",
      chapterName: "1. ÜNİTE: DOĞAL SİSTEMLER",
      topic: "Doğadaki Ekstrem Olaylar",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "12-TURKISH": {
      id: 3658,
      grade: 12,
      courseType: "TURKISH",
      chapterName: "1. ÜNİTE: GİRİŞ",
      topic: "Okuma",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "12-BIOLOGY": {
      id: 3051,
      grade: 12,
      courseType: "BIOLOGY",
      chapterName: "1. ÜNİTE: GENETİK BİLİMİ VE GEN MÜHENDİSLİĞİ",
      topic: "Nükleik Asitlerin Keşfi Ve Önemi",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "12-CHEMISTRY": {
      id: 3211,
      grade: 12,
      courseType: "CHEMISTRY",
      chapterName: "1. ÜNİTE: KİMYA VE ELEKTRİK",
      topic: "İndirgenme-yükseltgenme Tepkimelerinde Elektrik Akımı",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "12-PHYSICS": {
      id: 3821,
      grade: 12,
      courseType: "PHYSICS",
      chapterName: "1. ÜNİTE",
      topic: "Düzgün Çembersel Hareket",
      deletedOn: null,
      updatedAt: null,
      language: null,
    },
    "12-DIGITAL_CITIZENSHIP": {
      id: 7360,
      grade: 12,
      courseType: "DIGITAL_CITIZENSHIP",
      chapterName: "Dijital Medya ve Mental Sağlık",
      topic: "Dijital Medya Ve Mental Sağlık",
      deletedOn: null,
      updatedAt: "2024-12-06T17:53:02.000+00:00",
      language: null,
    },
    "12-AP_ASTRONOMY": {
      id: 5186,
      grade: null,
      courseType: "AP_ASTRONOMY",
      chapterName: "Science and the Universe: A Brief Tour",
      topic: "Introduction",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "12-AP_PSYCHOLOGY": {
      id: 4184,
      grade: null,
      courseType: "AP_PSYCHOLOGY",
      chapterName: "Introduction to Psychology",
      topic: "What Is Psychology?",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "12-AP_BUSINESS": {
      id: 4910,
      grade: null,
      courseType: "AP_BUSINESS",
      chapterName: "Understanding Economic Systems and Business",
      topic: "The Nature Of Business",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "12-AP_ECONOMICS": {
      id: 5044,
      grade: null,
      courseType: "AP_ECONOMICS",
      chapterName: "Welcome to Economics!",
      topic: "What Is Economics, And Why Is It Important?",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "12-AP_SOCIOLOGY": {
      id: 4716,
      grade: null,
      courseType: "AP_SOCIOLOGY",
      chapterName: "An Introduction to Sociology",
      topic: "What Is Sociology?",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "12-AP_WORLD_HISTORY_1": {
      id: 3938,
      grade: null,
      courseType: "AP_WORLD_HISTORY_1",
      chapterName: "Understanding the Past",
      topic: "Introduction",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "12-AP_WORLD_HISTORY_2": {
      id: 4790,
      grade: null,
      courseType: "AP_WORLD_HISTORY_2",
      chapterName: "Understanding the Past",
      topic: "Introduction",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "12-AP_BIOLOGY": {
      id: 4017,
      grade: null,
      courseType: "AP_BIOLOGY",
      chapterName: "1: The Study of Life",
      topic: "1.1 The Science Of Biology",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "12-AP_CHEMISTRY": {
      id: 5371,
      grade: null,
      courseType: "AP_CHEMISTRY",
      chapterName: "1: Essential Ideas",
      topic: "1.1 Chemistry In Context",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "12-AP_PHYSICS": {
      id: 4272,
      grade: null,
      courseType: "AP_PHYSICS",
      chapterName: "Introduction: The Nature of Science and Physics",
      topic: "Connection For Ap® Courses",
      deletedOn: null,
      updatedAt: "2024-12-07T11:19:42.795+00:00",
      language: null,
    },
    "12-IGCSE_BIOLOGY": {
      id: 9089,
      grade: null,
      courseType: "IGCSE_BIOLOGY",
      chapterName: "Characteristics and classification of living organisms",
      topic: "1.1 Characteristics of living organisms",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.545+00:00",
      language: null,
    },
    "12-IGCSE_PHYSICS": {
      id: 9328,
      grade: null,
      courseType: "IGCSE_PHYSICS",
      chapterName: "Motion, forces and energy",
      topic: "1.1 Physical quantities and measurement techniques",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.547+00:00",
      language: null,
    },
    "12-IGCSE_CHEMISTRY": {
      id: 9252,
      grade: null,
      courseType: "IGCSE_CHEMISTRY",
      chapterName: "States of matter",
      topic: "1.1 Solids, liquids and gases",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.546+00:00",
      language: null,
    },
    "12-IGCSE_BUSINESS_STUDIES": {
      id: 9303,
      grade: null,
      courseType: "IGCSE_BUSINESS_STUDIES",
      chapterName: "Understanding business activity",
      topic: "1.1 Business activity",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.547+00:00",
      language: null,
    },
    "12-IGCSE_ECONOMICS": {
      id: 9153,
      grade: null,
      courseType: "IGCSE_ECONOMICS",
      chapterName: "The basic economic problem",
      topic: "1.1 The nature of the economic problem",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.545+00:00",
      language: null,
    },
    "12-IGCSE_COMPUTER_SCIENCE": {
      id: 9192,
      grade: null,
      courseType: "IGCSE_COMPUTER_SCIENCE",
      chapterName: "Data representation",
      topic: "1.1 Number systems",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.546+00:00",
      language: null,
    },
    "12-IGCSE_GEOGRAPHY": {
      id: 9070,
      grade: null,
      courseType: "IGCSE_GEOGRAPHY",
      chapterName: "Population and settlement",
      topic: "1.1 Population dynamics",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.544+00:00",
      language: null,
    },
    "12-IGCSE_HISTORY": {
      id: 9221,
      grade: null,
      courseType: "IGCSE_HISTORY",
      chapterName:
        "Core content: Option A: The nineteenth century: the development of modern nation states, 1848–1914",
      topic: "1 Were the revolutions of 1848 important?",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.546+00:00",
      language: null,
    },
    "12-IGCSE_MATHEMATICS": {
      id: 8997,
      grade: null,
      courseType: "IGCSE_MATHEMATICS",
      chapterName: "Number",
      topic: "C1.1 Types of number",
      deletedOn: null,
      updatedAt: "2025-03-26T16:07:07.544+00:00",
      language: null,
    },
    "12-IB_DP_GEOGRAPHY": {
      id: 9579,
      grade: null,
      courseType: "IB_DP_GEOGRAPHY",
      chapterName: "Geographic themes-seven options",
      topic: "Freshwater",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.168+00:00",
      language: null,
    },
    "12-IB_DP_BUSINESS_MANAGEMENT": {
      id: 9542,
      grade: null,
      courseType: "IB_DP_BUSINESS_MANAGEMENT",
      chapterName: "Unit 1: Introduction to business management",
      topic: "1.1 What is a business?",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "12-IB_DP_CHEMISTRY": {
      id: 9520,
      grade: null,
      courseType: "IB_DP_CHEMISTRY",
      chapterName: "Structure 1. Models of the particulate nature of matter",
      topic: "Structure 1.1-Introduction to the particulate nature of matter",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "12-IB_DP_BIOLOGY": {
      id: 9480,
      grade: null,
      courseType: "IB_DP_BIOLOGY",
      chapterName: "Unity and diversity",
      topic: "Water",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "12-IB_DP_ECONOMICS": {
      id: 9449,
      grade: null,
      courseType: "IB_DP_ECONOMICS",
      chapterName: "Unit 1: Introduction to economics",
      topic: "1.1 What is economics?",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "12-IB_DP_HISTORY": {
      id: 9427,
      grade: null,
      courseType: "IB_DP_HISTORY",
      chapterName: "Prescribed subjects",
      topic: "Military leaders",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "12-IB_DP_PHYSICS": {
      id: 9403,
      grade: null,
      courseType: "IB_DP_PHYSICS",
      chapterName: "A Space, time and motion",
      topic: "A.1 Kinematics •",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "12-IB_DP_COMPUTER_SCIENCE": {
      id: 9392,
      grade: null,
      courseType: "IB_DP_COMPUTER_SCIENCE",
      chapterName: "Topic 1: System fundamentals",
      topic: "Topic 1: System fundamentals",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "12-IB_DP_MATHEMATICS": {
      id: 9387,
      grade: null,
      courseType: "IB_DP_MATHEMATICS",
      chapterName: "Number and algebra",
      topic: "Number and algebra",
      deletedOn: null,
      updatedAt: "2025-04-04T15:47:11.167+00:00",
      language: null,
    },
    "12-ALEVEL_BIOLOGY": {
      id: 10115,
      grade: null,
      courseType: "ALEVEL_BIOLOGY",
      chapterName: "Cell structure (AS Level)",
      topic: "1.1 The microscope in cell\nstudies",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.343+00:00",
      language: null,
    },
    "12-ALEVEL_BUSSINESS": {
      id: 9832,
      grade: null,
      courseType: "ALEVEL_BUSSINESS",
      chapterName: "Business and its environment (AS Level)",
      topic: "1.1 Enterprise",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.340+00:00",
      language: null,
    },
    "12-ALEVEL_CHEMISTRY": {
      id: 9648,
      grade: null,
      courseType: "ALEVEL_CHEMISTRY",
      chapterName: "Atomic structure",
      topic: "1.1 Particles in the atom and atomic radius",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.337+00:00",
      language: null,
    },
    "12-ALEVEL_COMPUTER_SCIENCE": {
      id: 9750,
      grade: null,
      courseType: "ALEVEL_COMPUTER_SCIENCE",
      chapterName: "Information representation",
      topic: "1.1 Data Representation",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.338+00:00",
      language: null,
    },
    "12-ALEVEL_ECONOMICS": {
      id: 9883,
      grade: null,
      courseType: "ALEVEL_ECONOMICS",
      chapterName: "Basic economic ideas and resource allocation (AS Level)",
      topic: "1.1 Scarcity, choice and opportunity cost",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.340+00:00",
      language: null,
    },
    "12-ALEVEL_EUROPEAN_HISTORY": {
      id: 9725,
      grade: null,
      courseType: "ALEVEL_EUROPEAN_HISTORY",
      chapterName: "Modern Europe, 1774-1924: France, 1774–1814",
      topic:
        "1.1 What were the causes and immediate consequences of the 1789 Revolution?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.338+00:00",
      language: null,
    },
    "12-ALEVEL_FURTHER_MATHEMATICS": {
      id: 9937,
      grade: null,
      courseType: "ALEVEL_FURTHER_MATHEMATICS",
      chapterName: "Further Pure Mathematics 1 (for Paper 1)",
      topic: "1.1 Roots of polynomial equations",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.341+00:00",
      language: null,
    },
    "12-ALEVEL_GEOGRAPHY": {
      id: 10059,
      grade: null,
      courseType: "ALEVEL_GEOGRAPHY",
      chapterName: "Hydrology and fluvial geomorphology",
      topic: "1.1 The drainage basin system",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.342+00:00",
      language: null,
    },
    "12-ALEVEL_INTERNATIONAL_HISTORY": {
      id: 10035,
      grade: null,
      courseType: "ALEVEL_INTERNATIONAL_HISTORY",
      chapterName: "Imperialism and the emergence of world powers c.1870–1918",
      topic: "1.1 Why was imperialism a significant force in Africa from 1870?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.342+00:00",
      language: null,
    },
    "12-ALEVEL_MATHEMATICS": {
      id: 9794,
      grade: null,
      courseType: "ALEVEL_MATHEMATICS",
      chapterName: "Pure Mathematics 1 (for Paper 1)",
      topic: "1.1 Quadratics",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.339+00:00",
      language: null,
    },
    "12-ALEVEL_PHYSICS": {
      id: 9961,
      grade: null,
      courseType: "ALEVEL_PHYSICS",
      chapterName: "Physical quantities and units",
      topic: "1.1 Physical quantities",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.341+00:00",
      language: null,
    },
    "12-ALEVEL_SOCIOLOGY": {
      id: 9598,
      grade: null,
      courseType: "ALEVEL_SOCIOLOGY",
      chapterName: "Socialisation and the creation of social identity",
      topic: "1.1 The process of learning and socialisation",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.336+00:00",
      language: null,
    },
    "12-ALEVEL_US_HISTORY_SINCE_1877": {
      id: 9868,
      grade: null,
      courseType: "ALEVEL_US_HISTORY_SINCE_1877",
      chapterName: "The Gilded Age and Progressive Era",
      topic:
        "1.1 What were the impacts of rapid economic growth in the US during the Gilded Age?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.340+00:00",
      language: null,
    },
    "12-ALEVEL_US_HISTORY_TO_1877": {
      id: 9633,
      grade: null,
      courseType: "ALEVEL_US_HISTORY_TO_1877",
      chapterName: "The American Civil War and Reconstruction, 1846–77.",
      topic:
        "1.1 How and why did sectional divisions widen between 1846 and 1861, resulting in the \n American Civil War?",
      deletedOn: null,
      updatedAt: "2025-04-10T17:56:55.336+00:00",
      language: null,
    },
    // "ubd-maarif-plan": {
    //   id: "ubd-maarif-plan",
    //   icon: ClipboardList,
    //   title: "sidebar.menu.lessonPlanningTools.ubdMaarifPlan",
    //   description: "ubdMaarifPlan.description",
    //   path: "/lesson-planning-tools/ubd-maarif-plan",
    //   colors: {
    //     gradient:
    //       "from-purple-600 to-indigo-600 dark:from-purple-400 dark:to-indigo-400",
    //     bgColor: "bg-purple-100 dark:bg-purple-900/50",
    //     iconColor: "text-purple-600 dark:text-purple-400",
    //     hoverBg: "hover:bg-purple-50 dark:hover:bg-purple-900/20",
    //     dashboardBg: "bg-purple-500",
    //     menuColor: "text-purple-600 dark:text-purple-400",
    //   },
    // },
  };

  if (courseType === "UNKNOWN") {
    courseType = "HISTORY";
  }

  if (grade === -1) {
    grade = 8;
  }

  if (courseType === "MATHEMATICS") {
    return {
      id: 123123,
      grade: grade,
      courseType: courseType,
      chapterName: "Kesirler",
      topic: "Kesirler ve Gerçek Hayat Uygulamaları",
      deletedOn: null,
      updatedAt: new Date().toISOString(),
      language: null,
    };
  }

  return allTopics[`${grade}-${courseType}` as keyof typeof allTopics] as {
    id: number;
    grade: number;
    courseType: BaseChatDtoCourse;
    chapterName: string;
    topic: string;
    deletedOn: null;
    updatedAt: null;
    language: null;
  };
};

export const formatDate = (date: string, locale: string = "tr-TR") => {
  return new Date(date).toLocaleString(locale, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export type ToolId =
  | "slides" // additional for now, get rid of it later
  | "podcasts"
  | "interactive-material"
  | "images"
  | "misconceptions"
  | "connections"
  | "summaries"
  | "text-leveler"
  | "vocabularies"
  | "choiceBoards"
  | "essentialQuestions"
  | "formativeAssessment"
  | "transferActivities"
  | "collaborative"
  | "hooks"
  | "exit-tickets"
  | "homework-ideas"
  | "ai-resistant-homework-idea"
  | "essay-grader"
  | "performance-task"
  | "classroom-management"
  | "rubric"
  | "project-based-learning"
  | "blooms-taxonomy-activity"
  | "ai-assignment-designer"
  | "ai-supported-tasks"
  | "heygenVideoGenerator"
  | "ai-assessment-scale";

export const toolCategories = {
  // Content Development
  podcasts: "content-development",
  "interactive-material": "content-development",
  images: "content-development",
  vocabularies: "content-development",
  summaries: "content-development",
  "text-leveler": "content-development",
  heygenVideoGenerator: "content-development",
  // Activity Planning
  connections: "activity-planning",
  hooks: "activity-planning",
  choiceBoards: "activity-planning",
  "classroom-management": "activity-planning",
  transferActivities: "activity-planning",
  "blooms-taxonomy-activity": "activity-planning",
  projectbasedlearning: "activity-planning",
  misconceptions: "activity-planning",
  collaborative: "activity-planning",
  essentialQuestions: "activity-planning",
  "ai-supported-tasks": "activity-planning",

  // Assessment & Evaluation
  formativeAssessment: "assessment-evaluation",
  "exit-tickets": "assessment-evaluation",
  "essay-grader": "assessment-evaluation",
  rubric: "assessment-evaluation",
  "homework-ideas": "assessment-evaluation",
  "ai-resistant-homework-idea": "assessment-evaluation",
  "ai-assignment-designer": "assessment-evaluation",
  "ai-assessment-scale": "assessment-evaluation",
  "performance-task": "assessment-evaluation",
};

export const getToolColorFromCategory = (toolId: ToolId) => {
  const category = toolCategories[toolId as keyof typeof toolCategories];
  return toolsList.find((tool) => tool.category === category)?.colors;
};

export const toolsList = [
  {
    category: "content-development",
    categoryTitle: "quickActions.categories.contentDevelopment",
    colors: {
      light: "from-green-600 to-green-600",
      dark: "dark:from-green-400 dark:to-green-400",
      iconBg: "bg-green-100 dark:bg-green-900/50",
      iconColor: "text-green-600 dark:text-green-400",
      hover: "hover:bg-green-50 dark:hover:bg-green-900/20",
      dashboardBg: "bg-green-600",
    },
    icon: FileText,
    tools: [
      {
        id: "podcasts" as ToolId,
        toolType: BaseTeacherToolResponseDtoToolType.PODCAST,
        icon: Podcast,
        title: "sidebar.menu.toolbox.podcasts",
        description: "podcast.description",
        path: "/podcast",
        createPath: "/podcast/new",
        createButtonText: "podcast.generateAudioLesson",
        colors: {
          light: "from-violet-600 to-purple-600",
          dark: "dark:from-violet-400 dark:to-purple-400",
          iconBg: "bg-violet-100 dark:bg-violet-900/50",
          iconColor: "text-violet-600 dark:text-violet-400",
          hover: "hover:bg-violet-50 dark:hover:bg-violet-900/20",
          dashboardBg: "bg-purple-500",
        },
        suggestedTools: [
          {
            route: "/content/interactive-materials/create",
            name: "interactiveMaterial",
          },
          { route: "/content/vocabularies/create", name: "vocabularies" },
          { route: "/content/summaries/create", name: "summaries" },
        ],
      },
      {
        id: "interactive-material" as ToolId,
        icon: SquareMousePointer, // Corrected icon name
        title: "quickActions.interactiveMaterial",
        description: "quickActions.interactiveMaterialDesc",
        path: "/content/interactive-materials",
        createPath: "/content/interactive-materials/create",
        // does not exist in the api
        toolType: "",
        createButtonText: "interactive_material.create.create",
        colors: {
          light: "from-rose-600 to-pink-600",
          dark: "dark:from-rose-400 dark:to-pink-400",
          iconBg: "bg-rose-100 dark:bg-rose-900/50",
          iconColor: "text-rose-600 dark:text-rose-400",
          hover: "hover:bg-rose-50 dark:hover:bg-rose-900/20",
          dashboardBg: "bg-rose-500",
        },
        suggestedTools: [
          { route: "/content/vocabularies/create", name: "vocabularies" },
          { route: "/content/summaries/create", name: "summaries" },
        ],
      },
      ...(getEnvironment() === "DEV"
        ? [
            {
              id: "heygenVideoGenerator" as ToolId,
              toolType: BaseTeacherToolResponseDtoToolType.HEYGEN_AVATAR,
              icon: Video,
              title: "quickActions.heygenVideoGenerator",
              description: "quickActions.heygenVideoGeneratorDesc",
              path: "/content/video-avatar-generator",
              createPath: "/content/video-avatar-generator/create",
              createButtonText: "quickActions.heygenVideoGeneratorCreate",
              colors: {
                light: "from-blue-600 to-indigo-600",
                dark: "dark:from-blue-400 dark:to-indigo-400",
                iconBg: "bg-blue-100 dark:bg-blue-900/50",
                iconColor: "text-blue-600 dark:text-blue-400",
                hover: "hover:bg-blue-50 dark:hover:bg-blue-900/20",
                dashboardBg: "bg-blue-600",
              },
            },
          ]
        : []),
      {
        id: "vocabularies" as ToolId,
        toolType: BaseTeacherToolResponseDtoToolType.VOCABULARY_LIST,
        icon: BookMarked,
        title: "quickActions.vocabularies",
        description: "quickActions.vocabulariesDesc",
        path: "/content/vocabularies",
        createPath: "/content/vocabularies/create",
        createButtonText: "quickActions.vocabulariesCreate",
        suggestedTools: [
          { route: "/content/connections/create", name: "connections" },
          { route: "/content/hooks/create", name: "hooks" },
          { route: "/content/exit-tickets/create", name: "exitTickets" },
        ],
        colors: {
          light: "from-cyan-600 to-cyan-500",
          dark: "dark:from-cyan-400 dark:to-cyan-300",
          iconBg: "bg-cyan-100 dark:bg-cyan-900/50",
          iconColor: "text-[#00acc1] dark:text-[#26c6da]",
          hover: "hover:bg-cyan-50 dark:hover:bg-cyan-900/20",
          dashboardBg: "bg-cyan-600",
        },
      },
      {
        id: "summaries" as ToolId,
        toolType: BaseTeacherToolResponseDtoToolType.SUMMARIZER,
        icon: LibrarySquare,
        title: "quickActions.summaries",
        description: "quickActions.summariesDesc",
        path: "/content/summaries",
        createPath: "/content/summaries/create",
        createButtonText: "quickActions.summariesCreate",
        colors: {
          light: "from-teal-600 to-emerald-600",
          dark: "dark:from-teal-400 dark:to-emerald-400",
          iconBg: "bg-teal-100 dark:bg-teal-900/50",
          iconColor: "text-teal-600 dark:text-teal-400",
          hover: "hover:bg-teal-50 dark:hover:bg-teal-900/20",
          dashboardBg: "bg-teal-600",
        },
        suggestedTools: [
          { route: "/content/vocabularies/create", name: "vocabularies" },
          {
            route: "/content/interactive-materials/create",
            name: "interactiveMaterial",
          },
        ],
      },
      {
        id: "text-leveler" as ToolId,
        toolType: BaseTeacherToolResponseDtoToolType.TEXT_LEVELER,
        icon: Gauge,
        title: "quickActions.textLeveler",
        description: "quickActions.textLevelerDesc",
        path: "/content/text-leveler",
        createPath: "/content/text-leveler/create",
        createButtonText: "quickActions.textLevelerCreate",
        colors: {
          light: "from-blue-600 to-sky-600",
          dark: "dark:from-blue-400 dark:to-sky-400",
          iconBg: "bg-blue-100 dark:bg-blue-900/50",
          iconColor: "text-textLeveler dark:text-textLeveler",
          hover: "hover:bg-blue-50 dark:hover:bg-blue-900/20",
          dashboardBg: "bg-blue-500",
        },
        suggestedTools: [
          { route: "/content/vocabularies/create", name: "vocabularies" },
          { route: "/content/summaries/create", name: "summaries" },
          {
            route: "/content/interactive-materials/create",
            name: "interactiveMaterial",
          },
        ],
      },
      {
        id: "images" as ToolId,
        toolType: BaseTeacherToolResponseDtoToolType.IMAGE_GENERATOR,
        icon: Sparkles,
        title: "sidebar.menu.images.title",
        description: "sidebar.menu.images.description",
        path: "/content/images",
        createPath: "/content/images",
        createButtonText: "sidebar.menu.images.create",
        colors: {
          light: "from-indigo-500 to-indigo-600",
          dark: "dark:from-indigo-400 dark:to-indigo-600",
          iconBg: "bg-indigo-100 dark:bg-indigo-900/50",
          iconColor: "text-indigo-600 dark:text-indigo-400",
          hover: "hover:bg-sky-50 dark:hover:bg-sky-900/20",
          dashboardBg: "bg-indigo-500",
        },
        suggestedTools: [
          {
            route: "/content/interactive-materials/create",
            name: "interactiveMaterial",
          },
          { route: "/content/summaries/create", name: "summaries" },
          { route: "/content/vocabularies/create", name: "vocabularies" },
        ],
      },
    ],
  },
  {
    category: "activity-planning",
    categoryTitle: "quickActions.categories.activityPlanning",
    colors: {
      light: "from-orange-600 to-orange-600",
      dark: "dark:from-orange-400 dark:to-orange-400",
      iconBg: "bg-orange-100 dark:bg-orange-900/50",
      iconColor: "text-orange-600 dark:text-orange-400",
      hover: "hover:bg-orange-50 dark:hover:bg-orange-900/20",
      dashboardBg: "bg-orange-600",
    },
    icon: ActivitySquare,
    tools: [
      {
        id: "connections" as ToolId,
        toolType: BaseTeacherToolResponseDtoToolType.REAL_WORLD_CONNECTION,
        icon: Earth,
        title: "quickActions.connections",
        description: "quickActions.connectionsDesc",
        path: "/content/connections",
        createPath: "/content/connections/create",
        createButtonText: "quickActions.connectionsCreate",
        suggestedTools: [
          { route: "/content/hooks/create", name: "hooks" },
          {
            route: "/content/transfer-activity/create",
            name: "transferActivities",
          },
          {
            route: "/content/project-based-learning/create",
            name: "projectbasedlearning",
          },
        ],
        colors: {
          light: "from-orange-600 to-orange-600",
          dark: "dark:from-orange-400 dark:to-orange-400",
          iconBg: "bg-orange-100 dark:bg-orange-900/50",
          iconColor: "text-orange-600 dark:text-orange-400",
          hover: "hover:bg-orange-50 dark:hover:bg-orange-900/20",
          dashboardBg: "bg-orange-600",
        },
      },
      {
        id: "hooks" as ToolId,
        toolType: BaseTeacherToolResponseDtoToolType.LESSON_HOOK,
        icon: Anchor,
        title: "quickActions.hooks",
        description: "quickActions.hooksDesc",
        path: "/content/hooks",
        createPath: "/content/hooks/create",
        createButtonText: "quickActions.hooksCreate",
        suggestedTools: [
          { route: "/content/connections/create", name: "connections" },
          { route: "/content/misconceptions/create", name: "misconceptions" },
          {
            route: "/content/essential-questions/create",
            name: "essentialQuestions",
          },
        ],
        colors: {
          light: "from-sky-400 to-sky-600",
          dark: "dark:from-sky-400 dark:to-sky-600",
          iconBg: "bg-sky-100 dark:bg-sky-900/50",
          iconColor: "text-sky-600 dark:text-sky-400",
          hover: "hover:bg-sky-50 dark:hover:bg-sky-900/20",
          dashboardBg: "bg-sky-600",
        },
      },
      {
        id: "choiceBoards" as ToolId,
        toolType: BaseTeacherToolResponseDtoToolType.CHOICE_BOARD,
        icon: CircuitBoard,
        title: "quickActions.choiceBoards",
        description: "quickActions.choiceBoardsDesc",
        path: "/content/choice-boards",
        createPath: "/content/choice-boards/create",
        createButtonText: "quickActions.choiceBoardsCreate",
        suggestedTools: [
          {
            route: "/content/project-based-learning/create",
            name: "projectbasedlearning",
          },
          {
            route: "/content/transfer-activity/create",
            name: "transferActivities",
          },
          {
            route: "/content/essential-questions/create",
            name: "essentialQuestions",
          },
        ],
        colors: {
          light: "from-green-600 to-green-600",
          dark: "dark:from-green-400 dark:to-green-400",
          iconBg: "bg-green-100 dark:bg-green-900/50",
          iconColor: "text-green-600 dark:text-green-600",
          hover: "hover:bg-green-50 dark:hover:bg-green-900/20",
          dashboardBg: "bg-green-500",
        },
      },
      {
        id: "classroom-management" as ToolId,
        toolType: BaseTeacherToolResponseDtoToolType.CLASSROOM_MANAGEMENT,
        icon: ShieldCheck,
        title: "quickActions.classroomManagement",
        description: "quickActions.classroomManagementDesc",
        path: "/content/classroom-management",
        createPath: "/content/classroom-management/create",
        createButtonText: "quickActions.classroomManagementCreate",
        suggestedTools: [
          { route: "/content/connections/create", name: "connections" },
          { route: "/content/misconceptions/create", name: "misconceptions" },
          {
            route: "/content/transfer-activity/create",
            name: "transferActivities",
          },
        ],
        colors: {
          light: "from-orange-500 to-orange-600",
          dark: "dark:from-orange-400 dark:to-orange-500",
          iconBg: "bg-orange-100 dark:bg-orange-900/50",
          iconColor: "text-orange-600 dark:text-orange-400",
          hover: "hover:bg-orange-50 dark:hover:bg-orange-900/20",
          dashboardBg: "bg-orange-500",
        },
      },
      {
        id: "transferActivities" as ToolId,
        toolType: BaseTeacherToolResponseDtoToolType.TRANSFER_ACTIVITY,
        icon: Activity,
        title: "quickActions.transferActivities",
        description: "quickActions.transferActivitiesDesc",
        path: "/content/transfer-activity",
        createPath: "/content/transfer-activity/create",
        createButtonText: "quickActions.transferActivitiesCreate",
        suggestedTools: [
          {
            route: "/content/performance-tasks/create",
            name: "performanceTask",
          },
          {
            route: "/content/project-based-learning/create",
            name: "projectbasedlearning",
          },
          { route: "/content/collaborative/create", name: "collaborative" },
        ],
        colors: {
          light: "from-[#D98787] to-[#C77272]",
          dark: "dark:from-[#E9A3A3] dark:to-[#D98787]",
          iconBg: "bg-[#FFF2F2] dark:bg-[#4D3535]/30",
          iconColor: "text-transferActivity dark:text-transferActivityDark",
          hover: "hover:bg-[#FFF2F2] dark:hover:bg-[#3D2828]/15",
          dashboardBg: "bg-[#D98787]",
        },
      },
      {
        id: "projectbasedlearning" as ToolId,
        toolType: BaseTeacherToolResponseDtoToolType.PROJECT_BASED_LEARNING,
        icon: ClipboardList,
        title: "quickActions.projectBasedLearning",
        description: "quickActions.projectBasedLearningDesc",
        path: "/content/project-based-learning",
        createPath: "/content/project-based-learning/create",
        createButtonText: "quickActions.projectBasedLearningCreate",
        suggestedTools: [
          { route: "/content/choice-boards/create", name: "choiceBoards" },
          { route: "/content/collaborative/create", name: "collaborative" },
          {
            route: "/content/transfer-activity/create",
            name: "transferActivities",
          },
        ],
        colors: {
          light: "bg-gradient-to-r from-[#F87171] to-[#EF4444]",
          dark: "dark:bg-gradient-to-r dark:from-[#FCA5A5] dark:to-[#F87171]",
          iconBg: "bg-[#FEF2F2] dark:bg-[#7F1D1D]/50",
          iconColor:
            "text-projectBasedLearning dark:text-projectBasedLearningDark",
          hover: "hover:bg-[#FEE2E2]/50 dark:hover:bg-[#7F1D1D]/20",
          dashboardBg: "bg-[#EF4444]",
        },
      },
      {
        id: "collaborative" as ToolId,
        toolType: BaseTeacherToolResponseDtoToolType.COLLABORATIVE_GROUP_WORK,
        icon: FolderSync,
        title: "quickActions.collaborative",
        description: "quickActions.collaborativeDesc",
        path: "/content/collaborative",
        createPath: "/content/collaborative/create",
        createButtonText: "quickActions.collaborativeCreate",
        suggestedTools: [
          {
            route: "/content/project-based-learning/create",
            name: "projectbasedlearning",
          },
          { route: "/content/choice-boards/create", name: "choiceBoards" },
          {
            route: "/content/transfer-activity/create",
            name: "transferActivities",
          },
        ],
        colors: {
          light: "from-[#BFA58A] to-[#A07E5E]",
          dark: "dark:from-[#C8B08D] dark:to-[#8B6F50]",
          iconBg: "bg-[#F5E0C3] dark:bg-[#6D4C3D]/30",
          iconColor: "text-collaborative dark:text-collaborativeDark",
          hover: "hover:bg-[#F0D9B5] dark:hover:bg-[#5C3D2E]/15",
          dashboardBg: "bg-[#A07E5E]",
        },
      },
      {
        id: "misconceptions" as ToolId,
        toolType: BaseTeacherToolResponseDtoToolType.COMMON_MISCONCEPTION,
        icon: AlertCircle,
        title: "quickActions.misconceptions",
        description: "quickActions.misconceptionsDesc",
        path: "/content/misconceptions",
        createPath: "/content/misconceptions/create",
        createButtonText: "quickActions.misconceptionsCreate",
        suggestedTools: [
          {
            route: "/content/essential-questions/create",
            name: "essentialQuestions",
          },
          { route: "/content/connections/create", name: "connections" },
          { route: "/content/hooks/create", name: "hooks" },
        ],
        colors: {
          light: "from-red-600 to-red-600",
          dark: "dark:from-red-400 dark:to-red-400",
          iconBg: "bg-red-100 dark:bg-red-900/50",
          iconColor: "text-red-600 dark:text-red-400",
          hover: "hover:bg-red-50 dark:hover:bg-red-900/20",
          dashboardBg: "bg-red-600",
        },
      },
      {
        id: "essentialQuestions" as ToolId,
        toolType: BaseTeacherToolResponseDtoToolType.ESSENTIAL_QUESTIONS,
        icon: MessageCircleQuestion,
        title: "quickActions.essentialQuestions",
        description: "quickActions.essentialQuestionsDesc",
        path: "/content/essential-questions",
        createPath: "/content/essential-questions/create",
        createButtonText: "quickActions.essentialQuestionsCreate",
        suggestedTools: [
          { route: "/content/misconceptions/create", name: "misconceptions" },
          {
            route: "/content/transfer-activity/create",
            name: "transferActivities",
          },
          {
            route: "/content/project-based-learning/create",
            name: "projectbasedlearning",
          },
        ],
        colors: {
          light: "from-purple-400 to-indigo-500",
          dark: "dark:from-purple-300 dark:to-indigo-400",
          iconBg: "bg-purple-100 dark:bg-purple-900/50",
          iconColor: "text-purple-400 dark:text-purple-300",
          hover: "hover:bg-purple-50 dark:hover:bg-purple-900/20",
          dashboardBg: "bg-purple-400",
        },
      },
      {
        id: "ai-supported-tasks" as ToolId,
        toolType: BaseTeacherToolResponseDtoToolType.AI_SUPPORTED_TASKS,
        icon: Sparkles,
        title: "quickActions.aiSupportedTasks",
        description: "quickActions.aiSupportedTasksDesc",
        path: "/content/ai-supported-tasks",
        createPath: "/content/ai-supported-tasks/create",
        createButtonText: "quickActions.aiSupportedTasksCreate",
        suggestedTools: [
          { route: "/content/choice-boards/create", name: "choiceBoards" },
          {
            route: "/content/transfer-activity/create",
            name: "transferActivities",
          },
          {
            route: "/content/essential-questions/create",
            name: "essentialQuestions",
          },
        ],
        colors: {
          light: "from-green-600 to-green-600",
          dark: "dark:from-green-400 dark:to-green-400",
          iconBg: "bg-green-100 dark:bg-green-900/50",
          iconColor: "text-green-600 dark:text-green-400",
          hover: "hover:bg-green-50 dark:hover:bg-green-900/20",
          dashboardBg: "bg-green-600",
        },
      },
      {
        id: "blooms-taxonomy-activity" as ToolId,
        toolType: BaseTeacherToolResponseDtoToolType.BLOOMS_TAXONOMY_ACTIVITIES,
        icon: Layers,
        title: "quickActions.bloomsTaxonomyActivity",
        description: "quickActions.bloomsTaxonomyActivityDesc",
        path: "/content/blooms-taxonomy-activities",
        createPath: "/content/blooms-taxonomy-activities/create",
        createButtonText: "quickActions.bloomsTaxonomyActivityCreate",
        suggestedTools: [
          {
            route: "/content/project-based-learning/create",
            name: "projectbasedlearning",
          },
          {
            route: "/content/essential-questions/create",
            name: "essentialQuestions",
          },
          { route: "/content/connections/create", name: "connections" },
        ],
        colors: {
          light: "from-[#F3C969] to-[#81C784]",
          dark: "dark:from-[#FFD54F] dark:to-[#66BB6A]",
          iconBg: "bg-[#FFF7E6] dark:bg-[#2E4223]/30",
          iconColor: "text-bloomsTaxonomy dark:text-bloomsTaxonomyDark",
          hover: "hover:bg-[#FFF7E6] dark:hover:bg-[#24331A]/15",
          dashboardBg: "bg-[#F3C969]",
        },
      },
    ],
  },
  {
    category: "assessment-evaluation",
    categoryTitle: "quickActions.categories.assessmentEvaluation",
    colors: {
      light: "from-blue-400 to-blue-600",
      dark: "dark:from-blue-300 dark:to-blue-500",
      iconBg: "bg-blue-100 dark:bg-blue-900/50",
      iconColor: "text-blue-600 dark:text-blue-400",
      hover: "hover:bg-blue-50 dark:hover:bg-blue-900/20",
      dashboardBg: "bg-blue-500",
    },
    icon: GraduationCap,
    tools: [
      {
        id: "formativeAssessment" as ToolId,
        toolType: BaseTeacherToolResponseDtoToolType.FORMATIVE_ASSESSMENT,
        icon: ClipboardList,
        title: "quickActions.formativeAssessment",
        description: "quickActions.formativeAssessmentDesc",
        path: "/content/formative-assessment",
        createPath: "/content/formative-assessment/create",
        createButtonText: "quickActions.formativeAssessmentCreate",
        suggestedTools: [
          { route: "/content/exit-tickets/create", name: "exitTickets" },
          {
            route: "/content/performance-tasks/create",
            name: "performanceTask",
          },
          { route: "/content/rubric/create", name: "rubric" },
        ],
        colors: {
          light: "from-yellow-300 to-orange-300",
          dark: "dark:from-yellow-300 dark:to-orange-300",
          iconBg: "bg-yellow-100 dark:bg-yellow-900/50",
          iconColor: "text-yellow-600 dark:text-yellow-400",
          hover: "hover:bg-yellow-50 dark:hover:bg-yellow-900/20",
          dashboardBg: "bg-yellow-500",
        },
      },
      {
        id: "exit-tickets" as ToolId,
        toolType: BaseTeacherToolResponseDtoToolType.EXIT_TICKET_GENERATOR,
        icon: Ticket,
        title: "quickActions.exitTickets",
        description: "quickActions.exitTicketsDesc",
        path: "/content/exit-tickets",
        createPath: "/content/exit-tickets/create",
        createButtonText: "quickActions.exitTicketsCreate",
        suggestedTools: [
          {
            route: "/content/formative-assessment/create",
            name: "formativeAssessment",
          },
          {
            route: "/content/performance-tasks/create",
            name: "performanceTask",
          },
          { route: "/content/homework-ideas/create", name: "homeworkIdeas" },
        ],
        colors: {
          light: "from-green-400 to-teal-500",
          dark: "dark:from-green-300 dark:to-teal-400",
          iconBg: "bg-green-100 dark:bg-teal-900/50",
          iconColor: "text-teal-600 dark:text-green-300",
          hover: "hover:bg-green-50 dark:hover:bg-teal-900/20",
          dashboardBg: "bg-teal-500",
        },
      },
      {
        id: "essay-grader" as ToolId,
        // does not exist in the api
        toolType: "",
        icon: Edit,
        title: "quickActions.compositionEvaluator",
        description: "quickActions.compositionEvaluatorDesc",
        path: "/assistants/new/essay-grader",
        createPath: "/assistants/new/essay-grader/create",
        createButtonText: "quickActions.compositionEvaluatorCreate",
        colors: {
          light: "from-purple-600 to-indigo-600",
          dark: "dark:from-purple-400 dark:to-indigo-400",
          iconBg: "bg-purple-100 dark:bg-purple-900/50",
          iconColor: "text-purple-600 dark:text-purple-400",
          hover: "hover:bg-purple-50 dark:hover:bg-purple-900/20",
          dashboardBg: "bg-purple-600",
        },
        suggestedTools: [
          { route: "/content/rubric/create", name: "rubric" },
          // {
          //   route: "/content/ai-assignment-designer/create",
          //   name: "ai-assignment-designer",
          // },
          {
            route: "/content/performance-tasks/create",
            name: "performanceTask",
          },
        ],
      },
      {
        id: "rubric" as ToolId,
        toolType: BaseTeacherToolResponseDtoToolType.RUBRIC_GENERATOR,
        icon: TextSelect,
        title: "quickActions.rubric",
        description: "quickActions.rubricDesc",
        path: "/content/rubric",
        createPath: "/content/rubric/create",
        createButtonText: "quickActions.rubricCreate",
        suggestedTools: [
          {
            route: "/content/performance-tasks/create",
            name: "performanceTask",
          },
          // {
          //   route: "/content/ai-assignment-designer/create",
          //   name: "ai-assignment-designer",
          // },
          {
            route: "/content/ai-assessment-scale/create",
            name: "ai-assessment-scale",
          },
        ],
        colors: {
          light: "from-[#7EA88E] to-[#4A7759]",
          dark: "dark:from-[#98C4A8] dark:to-[#5E8C6F]",
          iconBg: "bg-[#E8F1EB] dark:bg-[#2A3E33]/30",
          iconColor: "text-[#4A7759] dark:text-[#98C4A8]",
          hover: "hover:bg-[#F4F9F6] dark:hover:bg-[#2A3E33]/15",
          dashboardBg: "bg-[#4A7759]",
        },
      },
      {
        id: "homework-ideas" as ToolId,
        toolType: BaseTeacherToolResponseDtoToolType.HOMEWORK_IDEA,
        icon: BookOpen,
        title: "quickActions.homeworkIdeas",
        description: "quickActions.homeworkIdeasDesc",
        path: "/content/homework-ideas",
        createPath: "/content/homework-ideas/create",
        createButtonText: "quickActions.homeworkIdeasCreate",
        suggestedTools: [
          {
            route: "/content/ai-resistant-homework-ideas/create",
            name: "aiHomeworkIdeas",
          },
          {
            route: "/content/formative-assessment/create",
            name: "formativeAssessment",
          },
          {
            route: "/content/performance-tasks/create",
            name: "performanceTask",
          },
        ],
        colors: {
          light: "bg-gradient-to-r from-[#65A30D] to-[#16A34A]",
          dark: "dark:bg-gradient-to-r dark:from-[#A3E635] dark:to-[#4ADE80]",
          iconBg: "bg-[#ECFCCB] dark:bg-[#365314]/50",
          iconColor: "text-homeworkIdeas dark:text-homeworkIdeasDark",
          hover: "hover:bg-[#F7FEE7]/50 dark:hover:bg-[#365314]/20",
          dashboardBg: "bg-[#65A30D]",
        },
      },
      {
        id: "ai-resistant-homework-idea" as ToolId,
        toolType: BaseTeacherToolResponseDtoToolType.AI_RESISTANT_HOMEWORK,
        icon: BookAudio,
        title: "quickActions.aiHomeworkIdeas",
        description: "quickActions.aiHomeworkIdeasDesc",
        path: "/content/ai-resistant-homework-ideas",
        createPath: "/content/ai-resistant-homework-ideas/create",
        createButtonText: "quickActions.aiHomeworkIdeasCreate",
        suggestedTools: [
          { route: "/content/homework-ideas/create", name: "homeworkIdeas" },
          {
            route: "/content/formative-assessment/create",
            name: "formativeAssessment",
          },
        ],
        colors: {
          light: "from-teal-500 to-teal-600",
          dark: "dark:from-teal-400 dark:to-teal-600",
          iconBg: "bg-teal-100 dark:bg-teal-900/50",
          iconColor: "text-teal-600 dark:text-teal-400",
          hover: "hover:bg-sky-50 dark:hover:bg-sky-900/20",
          dashboardBg: "bg-teal-500",
        },
      },
      {
        id: "performance-task" as ToolId,
        toolType: BaseTeacherToolResponseDtoToolType.PERFORMANCE_TASK,
        icon: ShieldCheck,
        title: "quickActions.performanceTasks",
        description: "quickActions.performanceTasksDesc",
        path: "/content/performance-tasks",
        createPath: "/content/performance-tasks/create",
        createButtonText: "quickActions.performanceTasksCreate",
        suggestedTools: [
          {
            route: "/content/formative-assessment/create",
            name: "formativeAssessment",
          },
          { route: "/content/rubric/create", name: "rubric" },
          // {
          //   route: "/content/ai-assignment-designer/create",
          //   name: "ai-assignment-designer",
          // },
        ],
        colors: {
          light: "bg-gradient-to-r from-[#60A5FA] to-[#06B6D4]",
          dark: "dark:bg-gradient-to-r dark:from-[#93C5FD] dark:to-[#22D3EE]",
          iconBg: "bg-[#EFF6FF] dark:bg-[#172554]/50",
          iconColor: "text-performanceTasks dark:text-performanceTasksDark",
          hover: "hover:bg-[#DBEAFE]/50 dark:hover:bg-[#172554]/20",
          dashboardBg: "bg-[#60A5FA]",
        },
      },
      {
        id: "ai-assignment-designer" as ToolId,
        toolType: BaseTeacherToolResponseDtoToolType.AI_ASSIGNMENT,
        icon: Notebook,
        title: "quickActions.aiAssignmentDesigner",
        description: "quickActions.aiAssignmentDesignerDesc",
        path: "/content/ai-assignment-designer",
        createPath: "/content/ai-assignment-designer/create",
        createButtonText: "quickActions.aiAssignmentDesignerCreate",
        suggestedTools: [
          { route: "/content/rubric/create", name: "rubric" },
          {
            route: "/content/performance-tasks/create",
            name: "performanceTask",
          },
        ],
        colors: {
          light: "from-amber-500 to-amber-500",
          dark: "dark:from-amber-400 dark:to-amber-400",
          iconBg: "bg-amber-100 dark:bg-amber-900/50",
          iconColor: "text-amber-600 dark:text-amber-400",
          hover: "hover:bg-amber-50 dark:hover:bg-amber-900/20",
          dashboardBg: "bg-amber-600",
        },
      },
      {
        id: "ai-assessment-scale" as ToolId,
        toolType: BaseTeacherToolResponseDtoToolType.AI_ASSESSMENT_SCALE,
        icon: Gauge,
        title: "quickActions.aiAssessmentScale",
        description: "quickActions.aiAssessmentScaleDesc",
        path: "/content/ai-assessment-scale",
        createPath: "/content/ai-assessment-scale/create",
        createButtonText: "quickActions.aiAssessmentScaleCreate",
        suggestedTools: [
          { route: "/content/rubric/create", name: "rubric" },
          // {
          //   route: "/content/ai-assignment-designer/create",
          //   name: "ai-assignment-designer",
          // },
          {
            route: "/content/performance-tasks/create",
            name: "performanceTask",
          },
        ],
        colors: {
          light: "from-teal-500 to-teal-500",
          dark: "dark:from-teal-400 dark:to-teal-400",
          iconBg: "bg-teal-100 dark:bg-teal-900/50",
          iconColor: "text-teal-600 dark:text-teal-400",
          hover: "hover:bg-teal-50 dark:hover:bg-teal-900/20",
          dashboardBg: "bg-teal-500",
        },
      },
    ],
  },
];

export const DEFAULT_SUGGESTIONS = [
  {
    route: "/content/ai-resistant-homework-ideas/create",
    name: "aiHomeworkIdeas" as ToolId,
  },
  {
    route: "/content/project-based-learning/create",
    name: "projectBasedLearning" as ToolId,
  },
  {
    route: "/content/transfer-activity/create",
    name: "transferActivities" as ToolId,
  },
  {
    route: "/content/performance-tasks/create",
    name: "performanceTasks" as ToolId,
  },
  { route: "/content/connections/create", name: "connections" as ToolId },
];

export const lessonPlanningToolsList = [
  {
    id: "daily-plan",
    icon: ClipboardList,
    title: "sidebar.menu.lessonPlanningTools.dailyPlan",
    description: "dailyLessonPlan.description",
    path: "/lesson-planning-tools/daily-plan",
    colors: {
      gradient:
        "from-emerald-600 to-green-600 dark:from-emerald-400 dark:to-green-400",
      bgColor: "bg-emerald-100 dark:bg-emerald-900/50",
      iconColor: "text-emerald-600 dark:text-emerald-400",
      hoverBg: "hover:bg-emerald-50 dark:hover:bg-emerald-900/20",
      dashboardBg: "bg-emerald-500",
      menuColor: "text-emerald-600 dark:text-emerald-400",
    },
  },
  {
    id: "maarif-daily-plan",
    icon: Calendar,
    title: "sidebar.menu.lessonPlanningTools.maarifDailyPlan",
    description: "dailyLessonPlan.maarifDescription",
    path: "/lesson-planning-tools/maarif-daily-plan",
    colors: {
      gradient: "from-red-600 to-rose-600 dark:from-red-400 dark:to-rose-400",
      bgColor: "bg-red-100 dark:bg-red-900/50",
      iconColor: "text-red-600 dark:text-red-400",
      hoverBg: "hover:bg-red-50 dark:hover:bg-red-900/20",
      dashboardBg: "bg-red-500",
      menuColor: "text-red-600 dark:text-red-400",
    },
  },
  {
    id: "ted-plan",
    icon: BookOpen,
    title: "sidebar.menu.lessonPlanningTools.tedPlan",
    description: "",
    path: "/lesson-planning-tools/ted-plan",
    colors: {
      gradient: "from-blue-600 to-cyan-600 dark:from-blue-400 dark:to-cyan-400",
      bgColor: "bg-blue-100 dark:bg-blue-900/50",
      iconColor: "text-blue-600 dark:text-blue-400",
      hoverBg: "hover:bg-blue-50 dark:hover:bg-blue-900/20",
      dashboardBg: "bg-blue-500",
      menuColor: "text-blue-600 dark:text-blue-400",
    },
  },
  {
    id: "ubd-maarif-plan",
    icon: ClipboardList,
    title: "UbD Maarif Planı",
    description:
      "Anlamaya Dayalı Tasarım (UbD) Maarif Modeli ile ders planları oluşturun.",
    path: "/lesson-planning-tools/ubd-maarif-plan",
    colors: {
      gradient:
        "from-purple-600 to-indigo-600 dark:from-purple-400 dark:to-indigo-400",
      bgColor: "bg-purple-100 dark:bg-purple-900/50",
      iconColor: "text-purple-600 dark:text-purple-400",
      hoverBg: "hover:bg-purple-50 dark:hover:bg-purple-900/20",
      dashboardBg: "bg-purple-500",
      menuColor: "text-purple-600 dark:text-purple-400",
    },
  },
];
